import React, { useEffect, useMemo, useRef, useState } from "react";
import { auth, db } from "../firebase-config";
import { useNavigate } from "react-router-dom";
import { collection, doc, FieldPath, getDoc, getDocs, limit, onSnapshot, orderBy, query, setDoc, updateDoc, where } from "firebase/firestore";
import { pipelineDate, pipelineReadFilters, mergePipelineSnapshots } from '../dashboardPipelineData';

import { toast } from 'react-toastify';
import Header from "../components/Header";
import { getFirebaseDocs } from "../common";
import { useDispatch, useSelector } from "react-redux";
import { setCurrenDeclaration, setCurrenEoi, setDeclarations, setEois } from "../redux/eoiReducer";
import { addDays, addMonths, addYears, endOfMonth, endOfWeek, format, startOfMonth, startOfWeek, subMonths, subYears } from "date-fns";
import DisplayEoi from "../components/DisplayEoi";
// import DisplayQldEoi from "../components/DisplayQldEoi";
// import DisplayDeclaration from "../components/DisplayDeclaration";
// import { getFirebaseDocs } from "./common";
// import Listings from "./components/Listings";
import axios from 'axios'
import Dropdown from "../components/Dropdown";
// import MyCalendar from "../components/Calendar";
// import MyDropzone from "../components/MyDropzone";
// import ModalComponent from "../components/Modal";
// import Input from "../components/Input";
import { courseTrainers, createCourseOptions, trainers } from '../constants'
import DisplayDeclaration from "../components/DisplayDeclaration";
import ModalComponent from "../components/Modal";
import MyCalendar from "../components/Calendar";
import EditClassModal from '../components/EditClassModal';
import DisplayTrafficEoi from "../components/DisplayTrafficEoi";
import DisplayTrafficDeclaration from "../components/DisplayTrafficDeclaration";
import { isTrainerVerificationComplete } from "../studentDetailVerification";
import {
  buildDashboardCourseData,
  COURSE_DATA_CACHE_MS,
  DASHBOARD_COURSE_LABELS,
  DASHBOARD_COURSE_ROW_LIMIT,
  DASHBOARD_COURSE_SOURCES,
  dashboardCourseRowKey,
  dashboardCalendarClassKey,
  MIN_STUDENT_SEARCH_LENGTH,
} from "../dashboardCourseData";
import DisplayQldAdmin from "../components/DisplayQldAdmin";
import { dashboardViewUrl, readDashboardView } from '../dashboardViewState';
import TrainerProfileModal, { UploadCard } from "../components/TrainerProfileModal";
import CourseBuilder from "../components/CourseBuilder";
import TrafficCourseStageViewer, { getActivityChecklist, getTheoryReviewTargets } from "../components/TrafficCourseStageViewer";
import Logo from '../assets/Logo.svg';
import { clearPageMessage, showLoadingMessage, showSuccessMessage, showWarningMessage } from '../successMessage';
import {
  buildAdminClassDocument,
  buildAdminClassGroups,
  getClassStudentKey,
  deriveLegacyClassGroup,
  matchesRowToAdminClass,
  DASHBOARD_TABS,
  getAdminClassTypeKeyForTab,
  QLD_TAB,
} from "../adminClassUtils";
import {
  getFlowTaskById,
  getTaskState,
  getTrafficStageStatusLabel,
  TRAINER_DECLARATION_TYPE,
} from "../trafficCourseFlowUtils";

const DASHBOARD_COURSE_TABS = {
  whiteCard: 'White Card',
  trafficControl: 'Traffic Control',
  trafficImplement: 'Traffic Implement',
  qldWhiteCard: 'Qld',
}

const Dashboard = () => {

  const tabs = [...DASHBOARD_TABS, 'Trainers', 'Compliance', 'Admin', 'Course Builder', 'My Profile']
  const primaryTabs = ['Dashboard', 'Classes', 'Students', 'Trainers', 'Courses', 'Compliance', 'Reports', 'Stats', 'Admin']
  const placeholderTabs = ['Dashboard', 'Trainers', 'Compliance', 'Reports', 'Stats', 'Admin', 'Course Builder', 'My Profile']
  const adminOnlyTabs = ['Courses', 'Admin', 'Course Builder']
  const qldTab = QLD_TAB
  const [initialView] = useState(() => readDashboardView(window.location.search, [...tabs, ...primaryTabs], DASHBOARD_TABS))
  const [selectedTrainerProfile, setSelectedTrainerProfile] = useState(null)
  const [trainerComplianceStatuses, setTrainerComplianceStatuses] = useState({})
  const [editingClass, setEditingClass] = useState(null)
  const [classEditVersion, setClassEditVersion] = useState(0)
  const courseConfigMap = {
    'White Card': {
      eoiDb: 'eoi',
      declarationDb: 'declaration',
      type: 'white-card',
    },
    'Traffic Control': {
      eoiDb: 'trafficControl',
      declarationDb: 'dec-trafficControl',
      type: 'traffic-control',
    },
    'Traffic Implement': {
      eoiDb: 'trafficImplementation',
      declarationDb: 'dec-trafficImplementation',
      type: 'traffic-implement',
    },
  }

  const [userData, setUserData] = useState(null)
  const [loading, setLoading] = useState(false)
  // const [errors, setErrors] = useState([])
  // const [errorMessage, setErrorMessage] = useState('')
  const [currentTab, setCurrentTab] = useState(initialView.currentTab)
  const [enableMultiSelect, setEnableMultiSelect] = useState(false)
  const [selectedRows, setSelectedRows] = useState([])
  const [selectedSubmissionType, setSelectedSubmissionType] = useState('eoi')
  const [filter, setFilter] = useState(() => {
    const trainer = trainers.find(row => row.trainerId === initialView.trainerId)
    return trainer ? { value: trainer.trainerId, label: trainer.name } : undefined
  })
  const [classDateFilter, setClassDateFilter] = useState(initialView.classDateFilter)
  const [classCourseFilter, setClassCourseFilter] = useState(initialView.classCourseFilter)
  const [showClassResults, setShowClassResults] = useState(initialView.showClassResults)
  const [classResultsPage, setClassResultsPage] = useState(1)
  const [search, setSearch] = useState('')
  const [startDate, setStartDate] = useState(subYears(new Date(), 1))
  const [endDate, setEndDate] = useState(new Date())


  const [courseStartDates, setCourseStartDates] = useState([addDays(new Date(), 14)])

  const [courseType, setCourseType] = useState('')
  const [courseTrainer, setCourseTrainer] = useState('')


  const [showGenerateReport, setShowGenerateReport] = useState(false)
  const [qiReportCourse, setQiReportCourse] = useState('Traffic Control')

  const [showCreateCourses, setShowCreateCourses] = useState(false)
  const [qldCreateSignal, setQldCreateSignal] = useState(0)
  const [qldStudentNumbersSignal, setQldStudentNumbersSignal] = useState(0)
  const [qldGcitSignal, setQldGcitSignal] = useState(0)
  const [qldToolbarState, setQldToolbarState] = useState({ canGenerateGcit: false, isGeneratingGcit: false })
  const [adminClasses, setAdminClasses] = useState([])
  const [selectedClassId, setSelectedClassId] = useState(initialView.selectedClassId)
  const [trafficCourseFlows, setTrafficCourseFlows] = useState([])
  const [trafficControllerTemplateTasks, setTrafficControllerTemplateTasks] = useState([])
  const [bulkReleasingTrafficTaskId, setBulkReleasingTrafficTaskId] = useState('')
  const [showReportsPopup, setShowReportsPopup] = useState(false)
  const [reportStartDate, setReportStartDate] = useState(new Date())
  const [reportEndDate, setReportEndDate] = useState(new Date())
  const [reportCourse, setReportCourse] = useState('')
  const [reportTrainer, setReportTrainer] = useState('')
  const [reportType, setReportType] = useState('')

  const [courseNo, setCourseNo] = useState('')
  const [username, setUserName] = useState('')
  const [password, setPassword] = useState('')
  const [courseNoAlternate, setCourseNoAlternate] = useState('')
  const [showLodgePopup, setShowLodgePopup] = useState(false)
  const [showLodgeTrafficPopup, setShowLodgeTrafficPopup] = useState(false)
  const [showStudentDetailsPopup, setShowStudentDetailsPopup] = useState(false)
  const [isDeclarationEditing, setIsDeclarationEditing] = useState(false)
  const [selectedTrafficFlowStage, setSelectedTrafficFlowStage] = useState(null)
  const [verificationStatusMessage, setVerificationStatusMessage] = useState(null)
  const [lodgeConfirmations, setLodgeConfirmations] = useState({})
  const [showDownloadEoiPopup, setShowDownloadEoiPopup] = useState(false)
  const [markTask, setMarkTask] = useState(null)
  const [markDraft, setMarkDraft] = useState({})
  const [savingTrafficMarks, setSavingTrafficMarks] = useState(false)
  const [coursesSidebarCollapsed, setCoursesSidebarCollapsed] = useState(() => window.localStorage.getItem('upskill-courses-sidebar') === 'collapsed')
  const [downloadEoiIds, setDownloadEoiIds] = useState([])
  const [dashboardMonth, setDashboardMonth] = useState(() => startOfMonth(new Date()))
  const [dashboardDerivedClasses, setDashboardDerivedClasses] = useState([])
  const [dashboardCourseRows, setDashboardCourseRows] = useState([])
  const [dashboardStudentSearch, setDashboardStudentSearch] = useState('')
  const [studentDirectorySearch, setStudentDirectorySearch] = useState('')
  const [selectedStudentProfile, setSelectedStudentProfile] = useState(null)
  const [studentResultsPage, setStudentResultsPage] = useState(1)
  const [courseWorkspace, setCourseWorkspace] = useState(initialView.courseWorkspace)
  const [statsMonth, setStatsMonth] = useState(() => startOfMonth(new Date()))
  const courseDataLoadRef = useRef({ userKey: '', mode: '', loadedAt: 0 })
  const [dashboardMonthRows, setDashboardMonthRows] = useState([])
  const [dashboardMonthClasses, setDashboardMonthClasses] = useState([])
  const monthDataLoadRef = useRef({ userKey: '', monthKey: '' })
  const calendarMonthTouchedRef = useRef(false)
  const courseDataLoadsInFlightRef = useRef(0)
  const requestedClassIdRef = useRef(initialView.selectedClassId)
  const [loadingCourseData, setLoadingCourseData] = useState(false)
  const [pipelineRefresh, setPipelineRefresh] = useState(0)
  const [pipelineLoadError, setPipelineLoadError] = useState('')

  const isAdminUser = userData?.role === 'admin'
  const visiblePrimaryTabs = isAdminUser
    ? primaryTabs
    : ['Dashboard', 'My Classes', 'My Profile']
  const myProfileNameParts = String(userData?.name || '').trim().split(/\s+/).filter(Boolean)
  const myProfileLastName = userData?.lastName || (myProfileNameParts.length > 1 ? myProfileNameParts[myProfileNameParts.length - 1] : '')
  const myProfileFirstName = userData?.firstName || (myProfileNameParts.length > 1 ? myProfileNameParts.slice(0, -1).join(' ') : myProfileNameParts[0] || '')

  const currentCourseConfig = courseConfigMap[currentTab] || null
  const isTrafficCourse = currentCourseConfig?.type === 'traffic-control' || currentCourseConfig?.type === 'traffic-implement'
  const focusedPipeline = courseWorkspace === 'classes' && Boolean(selectedClassId) && !showClassResults && Boolean(currentCourseConfig)
  const focusedPipelineDate = focusedPipeline ? pipelineDate(selectedClassId, adminClasses) : ''

  const lodgeFieldRowStyle = { display: 'flex', alignItems: 'center', gap: '12px', marginTop: '10px' }
  const lodgeFieldLabelStyle = { minWidth: '230px' }
  const lodgeFieldInputStyle = { width: '220px', border: '1px solid black', margin: 0 }
  const reportCourseOptions = ['White Card EOI', 'Traffic Control EOI', 'Traffic Implement EOI']
  const reportTypeOptions = ['Verification report', 'Changes report']
  const reportTrainerOptions = ['All Trainers', ...trainers.map((trainer) => trainer.name)]

  const navigate = useNavigate()

  const uid = useSelector((state) => state.user.uid)

  const downloadFileUrl = 'https://australia-southeast1-upskillinstitute-au.cloudfunctions.net/downloadFile'


  useEffect(() => {
    const nextUrl = dashboardViewUrl(window.location.href, {
      currentTab, courseWorkspace, selectedClassId, classCourseFilter,
      classDateFilter, trainerId: filter?.value || '', showClassResults,
    })
    // Replace rather than push: class/filter changes should not flood browser history.
    window.history.replaceState(window.history.state, '', nextUrl)
  }, [currentTab, courseWorkspace, selectedClassId, classCourseFilter, classDateFilter, filter, showClassResults])


  useEffect(() => {
    if (!userData || isAdminUser || !adminOnlyTabs.includes(currentTab)) {
      return
    }

    setCurrentTab(tabs[0])
  }, [userData, isAdminUser, currentTab])

  useEffect(() => {
    window.localStorage.setItem('upskill-courses-sidebar', coursesSidebarCollapsed ? 'collapsed' : 'expanded')
  }, [coursesSidebarCollapsed])

  useEffect(() => {
    const currentTabIndex = tabs.findIndex((row) => row === currentTab)
    window.localStorage.setItem('upskill-admin-tab', currentTabIndex >= 0 ? currentTabIndex : 0)
  }, [currentTab])

  useEffect(() => {

    if (!focusedPipeline) performFetch(false)

  }, [userData, currentTab, filter, focusedPipeline])

  useEffect(() => {
    if (!userData || currentTab === qldTab || (placeholderTabs.includes(currentTab) && currentTab !== 'Dashboard')) {
      return
    }

    fetchAdminClasses()
  }, [userData, currentTab, filter, classCourseFilter])

  useEffect(() => {
    if (!userData || !isTrafficCourse) {
      setTrafficCourseFlows([])
      return undefined
    }

    if (focusedPipeline) {
      let active = true
      const snapshots = new Map()
      setTrafficCourseFlows([])
      const unsubscribes = pipelineReadFilters(selectedClassId, focusedPipelineDate, { flows: true }).map((filters, index) => (
        onSnapshot(query(collection(db, 'trafficCourseFlows'), ...filters.map(args => where(...args))), snapshot => {
          if (!active) return
          snapshots.set(index, snapshot)
          const rows = getFirebaseDocs({ docs: mergePipelineSnapshots([...snapshots.values()]) }).filter(row => {
            if (row.trainingType !== (currentTab === 'Traffic Control' ? 'trafficControl' : 'trafficImplementation')) return false
            const trainer = userData.role === 'trainer' ? userData.trainerId : filter?.value
            return !trainer || row.trainerId === trainer
          })
          setTrafficCourseFlows(rows)
        }, error => console.error('error loading class assessment flows', error))
      ))
      return () => { active = false; unsubscribes.forEach(unsubscribe => unsubscribe()) }
    }

    let constraints = [where('trainingType', '==', currentTab === 'Traffic Control' ? 'trafficControl' : 'trafficImplementation')]

    if (userData.role === 'trainer') {
      constraints = [...constraints, where('trainerId', '==', userData.trainerId)]
    } else if (userData.role === 'admin' && filter?.value) {
      constraints = [...constraints, where('trainerId', '==', filter.value)]
    }

    const snapshotQuery = query(collection(db, 'trafficCourseFlows'), ...constraints)
    const unsubscribe = onSnapshot(snapshotQuery, (snapshot) => {
      const rows = getFirebaseDocs(snapshot).sort((left, right) => (
          new Date(right.updatedAt || right.createdAt || 0).getTime() - new Date(left.updatedAt || left.createdAt || 0).getTime()
        ))
      setTrafficCourseFlows(rows)
    }, (trafficFlowError) => {
      console.error('error loading traffic course flows', trafficFlowError)
    })

    return () => unsubscribe()
  }, [currentTab, filter, userData, qldTab, isTrafficCourse, focusedPipeline, focusedPipelineDate, selectedClassId])

  useEffect(() => {
    if (!userData || !isTrafficCourse) {
      setTrafficControllerTemplateTasks([])
      return
    }

    const fetchTrafficControllerTemplate = async () => {
      try {
        const linkedCourse = currentTab === 'Traffic Control' ? 'traffic-controller' : 'traffic-implementer'
        const snapshot = await getDocs(query(collection(db, 'courseBuilderCourses'), where('linkedCourse', '==', linkedCourse)))
        const rows = getFirebaseDocs(snapshot)
          .sort((left, right) => (Number(right.updatedAtMs || 0) - Number(left.updatedAtMs || 0)))
        setTrafficControllerTemplateTasks(rows[0]?.tasks || [])
      } catch (courseBuilderError) {
        console.error('error loading traffic course template', courseBuilderError)
        setTrafficControllerTemplateTasks([])
      }
    }

    fetchTrafficControllerTemplate()
  }, [currentTab, userData, isTrafficCourse])

  const loadMoreStudents = () => {
    performFetch(true)
  }

  const performFetch = (removeLimits) => {
    if (focusedPipeline) {
      courseDataLoadRef.current = { userKey: '', mode: '', loadedAt: 0 }
      setPipelineRefresh(version => version + 1)
      return
    }
    if (userData) {
      if (currentTab === qldTab) {
        return
      }

      if (currentTab === 'White Card') {
        fetchEoi(removeLimits, 'eoi')
        fetchDeclarations(removeLimits, 'declaration')
      } else if (currentTab === 'Traffic Control') {
        fetchTrafficEoi(removeLimits, 'trafficControl')
        fetchTrafficDeclarations(removeLimits, 'dec-trafficControl')
      } else if (currentTab === 'Traffic Implement') {
        fetchTrafficEoi(removeLimits, 'trafficImplementation')
        fetchTrafficDeclarations(removeLimits, 'dec-trafficImplementation')
      }
    }
  }

  useEffect(() => {
    if (uid) {
      fetchUserData(uid)
    }
  }, [uid])

  const dispatch = useDispatch()

  const eois = useSelector((state) => state.eoi.eois)
  const currentEoi = useSelector((state) => state.eoi.currentEoi)
  // const qldEois = useSelector((state) => state.eoi.qldEois)
  // const currentQldEoi = useSelector((state) => state.eoi.currentQldEoi)

  const declarations = useSelector((state) => state.eoi.declarations)
  const currentDeclaration = useSelector((state) => state.eoi.currentDeclaration)

  const handleCurrentEoiUpdated = (nextEoi) => {
    if (!nextEoi) {
      return
    }

    dispatch(setCurrenEoi(nextEoi))
    dispatch(setEois(eois.map((row) => row.id === nextEoi.id ? nextEoi : row)))
    setDashboardCourseRows(rows => rows.map(row => row.id === nextEoi.id && row.submissionType === 'eoi' && row.dashboardCourseTab === currentTab ? { ...row, ...nextEoi } : row))
  }

  // const qldAssessments = useSelector((state) => state.eoi.qldAssessments)
  // const currentQldAssessment = useSelector((state) => state.eoi.currentQldAssessment)

  const addLimitClause = removeLimits => removeLimits ? [] : [limit(200)]

  const fetchEoi = async (removeLimits, database = 'eoi') => {

    try {
      let whereCondition = userData.role === 'trainer' ? [where('data.trainerId', '==', userData.trainerId)] : []

      if (userData.role === 'admin' && filter) {
        whereCondition = [where('data.trainerId', '==', filter.value)]
      }
      let limitCondition = addLimitClause(removeLimits)
      const records = await getFirebaseDocs(await getDocs(query(collection(db, database), ...whereCondition, orderBy('Created', 'desc'), ...limitCondition)))

      if (database === 'eoi') {
        dispatch(setEois([]))
        dispatch(setEois(records))

        if (currentEoi) {
          const matchingRecord = records.find(row => row.id === currentEoi.id)
          dispatch(setCurrenEoi())
          setTimeout(() => {
            dispatch(setCurrenEoi(matchingRecord))
          }, 50)
        }
      }

    } catch (e) {
      console.log('error', e)
    }
  }

  // 'trafficControl' : 'trafficImplementation'

  const fetchTrafficEoi = async (removeLimits, database = 'trafficControl') => {
    try {
      let whereCondition = userData.role === 'trainer' ? [where('data.trainerId', '==', userData.trainerId)] : []

      if (userData.role === 'admin' && filter) {
        whereCondition = [where('data.trainerId', '==', filter.value)]
      }
      let limitCondition = addLimitClause(removeLimits)
      const records = await getFirebaseDocs(await getDocs(query(collection(db, database), ...whereCondition, orderBy('Created', 'desc'), ...limitCondition)))

      // if (database === 'trafficControl') {
      dispatch(setEois([]))
      dispatch(setEois(records))

      if (currentEoi) {
        const matchingRecord = records.find(row => row.id === currentEoi.id)
        dispatch(setCurrenEoi())
        setTimeout(() => {
          dispatch(setCurrenEoi(matchingRecord))
        }, 50)
      }
      // }

    } catch (e) {
      console.log('error', e)
    }
  }


  const fetchDeclarations = async (removeLimits, database = 'declaration') => {
    try {
      let whereCondition = userData.role === 'trainer' ? [where('data.trainerId', '==', userData.trainerId)] : []

      if (userData.role === 'admin' && filter) {
        whereCondition = [where('data.trainerId', '==', filter.value)]
      }

      let limitCondition = addLimitClause(removeLimits)

      const records = await getFirebaseDocs(await getDocs(query(collection(db, database), ...whereCondition, orderBy('Created', 'desc'), ...limitCondition)))
      // console.log('records', records)
      dispatch(setDeclarations([]))
      dispatch(setDeclarations(records))
      if (currentDeclaration) {
        const matchingRecord = records.find(row => row.id === currentDeclaration.id)
        dispatch(setCurrenDeclaration())
        setTimeout(() => {
          dispatch(setCurrenDeclaration(matchingRecord))
        }, 50)
      }
    } catch (e) {
      console.log('error', e)
    }
  }
  // 'dec-trafficControl' : 'dec-trafficImplementation',

  const fetchTrafficDeclarations = async (removeLimits, database = 'dec-trafficControl') => {
    try {
      let whereCondition = userData.role === 'trainer' ? [where('data.trainerId', '==', userData.trainerId)] : []

      if (userData.role === 'admin' && filter) {
        whereCondition = [where('data.trainerId', '==', filter.value)]
      }

      let limitCondition = addLimitClause(removeLimits)

      const records = await getFirebaseDocs(await getDocs(query(collection(db, database), ...whereCondition, orderBy('Created', 'desc'), ...limitCondition)))
      // console.log('records', records)
      dispatch(setDeclarations([]))
      dispatch(setDeclarations(records))
      if (currentDeclaration) {
        const matchingRecord = records.find(row => row.id === currentDeclaration.id)
        dispatch(setCurrenDeclaration())
        setTimeout(() => {
          dispatch(setCurrenDeclaration(matchingRecord))
        }, 50)
      }
    } catch (e) {
      console.log('error', e)
    }
  }


  useEffect(() => {
    if (!enableMultiSelect) {
      setSelectedRows([])
    }
  }, [enableMultiSelect])

  useEffect(() => {
    setLodgeConfirmations(
      selectedRows.reduce((acc, row) => ({
        ...acc,
        [row.id]: false
      }), {})
    )
  }, [selectedRows])


  const fetchUserData = async (uid) => {

    try {
      setLoading(true)
      const userData = await (await getDoc(doc(db, 'users', uid))).data()
      if (!userData) {
        toast.error("User doesn't exist in system. Taking you back to login page.", { position: 'top-center' })
        setTimeout(async () => {
          await signOutUser()
          navigate('/login')
        }, 3000)
        return
      }
      setUserData({ ...userData, id: uid })
      setLoading(false)
    } catch (e) {
      console.error('firebase login error', e)
    }
  }

  const fetchAdminClasses = async () => {
    try {
      const snapshot = await getDocs(collection(db, 'adminClasses'))
      const rows = getFirebaseDocs(snapshot)
      const currentClassTypeKey = getAdminClassTypeKeyForTab(currentTab)
      const filteredRows = rows
        .filter((row) => currentTab === 'Dashboard' || classCourseFilter === '__all__' || row.courseTypeKey === currentClassTypeKey)
        .filter((row) => {
          if (userData?.role === 'trainer') {
            return String(row.trainerId || '').trim().toLowerCase() === String(userData.trainerId || '').trim().toLowerCase()
          }

          if (userData?.role === 'admin' && filter?.value && currentTab !== 'Dashboard') {
            return row.trainerId === filter.value
          }

          return true
        })
        .sort((left, right) => new Date(right.scheduledDate || right.createdAt || 0).getTime() - new Date(left.scheduledDate || left.createdAt || 0).getTime())

      setAdminClasses(filteredRows)
    } catch (e) {
      setAdminClasses([])
      console.log('error loading admin classes', e)
      if (e?.code !== 'permission-denied') {
        showWarningMessage('Classes could not be loaded. Showing grouped student submissions instead.')
      }
    }
  }

  useEffect(() => {
    // Searching every student needs the whole history, so only ask for it once the
    // trainer has typed enough to mean it rather than on the first stray keystroke.
    const studentSearchRequested = currentTab === 'Students' && studentDirectorySearch.trim().length >= MIN_STUDENT_SEARCH_LENGTH
    const dashboardSearchRequested = currentTab === 'Dashboard' && dashboardStudentSearch.trim().length >= MIN_STUDENT_SEARCH_LENGTH
    const needsCourseData = currentTab === 'Dashboard' || currentTab === 'Stats' || courseWorkspace === 'classes' || studentSearchRequested || dashboardSearchRequested
    if (!userData || !needsCourseData) {
      return
    }

    const loadMode = focusedPipeline ? `pipeline:${selectedClassId}:${focusedPipelineDate}` : studentSearchRequested || dashboardSearchRequested || currentTab === 'Stats' ? 'full' : 'limited'
    const userKey = String(userData?.email || userData?.trainerId || userData?.role || '')
    const previousLoad = courseDataLoadRef.current
    const cachedForUser = previousLoad.userKey === userKey && Date.now() - previousLoad.loadedAt < COURSE_DATA_CACHE_MS
    if (cachedForUser && (previousLoad.mode === loadMode || (!focusedPipeline && previousLoad.mode === 'full'))) {
      return
    }
    courseDataLoadRef.current = { userKey, mode: loadMode, loadedAt: Date.now() }
    let active = true

    const loadCourseGroups = async () => {
      courseDataLoadsInFlightRef.current += 1
      setLoadingCourseData(true)
      if (focusedPipeline) setPipelineLoadError('')
      try {
        const snapshots = await Promise.allSettled(DASHBOARD_COURSE_SOURCES.map((source) => (
          focusedPipeline
            ? Promise.all(pipelineReadFilters(selectedClassId, focusedPipelineDate).map(filters => getDocs(query(collection(db, source.collectionName), ...filters.map(args => where(...args))))))
              .then(results => ({ docs: mergePipelineSnapshots(results) }))
            : getDocs(loadMode === 'full'
            ? query(collection(db, source.collectionName), orderBy('Created', 'desc'))
            : query(collection(db, source.collectionName), orderBy('Created', 'desc'), limit(DASHBOARD_COURSE_ROW_LIMIT)))
        )))
        if (!active) return
        const sourceResults = snapshots.map((result, index) => {
          const source = DASHBOARD_COURSE_SOURCES[index]
          if (result.status !== 'fulfilled') {
            console.log(`error loading dashboard ${source.collectionName}`, result.reason)
            if (focusedPipeline) setPipelineLoadError('Some class records could not be loaded. Please retry before marking or lodging students.')
            return { source, docs: [] }
          }

          return { source, docs: getFirebaseDocs(result.value) }
        })
        const { rows, classes } = buildDashboardCourseData(sourceResults, { role: userData?.role, trainerId: userData?.trainerId })

        setDashboardDerivedClasses(classes)
        setDashboardCourseRows(rows)
      } catch (error) {
        if (!active) return
        console.log('error loading dashboard course groups', error)
        setDashboardDerivedClasses([])
        setDashboardCourseRows([])
        courseDataLoadRef.current = { userKey, mode: '', loadedAt: 0 }
      } finally {
        courseDataLoadsInFlightRef.current -= 1
        if (courseDataLoadsInFlightRef.current === 0) {
          setLoadingCourseData(false)
        }
      }
    }

    loadCourseGroups()
    return () => { active = false; courseDataLoadRef.current = { userKey: '', mode: '', loadedAt: 0 } }
  }, [courseWorkspace, currentTab, dashboardStudentSearch, studentDirectorySearch, userData, classEditVersion, focusedPipeline, focusedPipelineDate, selectedClassId, pipelineRefresh])

  // The recent-rows load only reaches back so far, so the calendar fetches exactly the
  // month on screen. Created is a unix timestamp, so this is a single-field range read.
  useEffect(() => {
    if (!userData || currentTab !== 'Dashboard') {
      return
    }

    const monthKey = format(dashboardMonth, 'yyyy-MM')
    const userKey = String(userData?.email || userData?.trainerId || userData?.role || '')
    if (monthDataLoadRef.current.userKey === userKey && monthDataLoadRef.current.monthKey === monthKey) {
      return
    }
    monthDataLoadRef.current = { userKey, monthKey }

    const loadMonth = async () => {
      const fromSeconds = Math.floor(startOfMonth(dashboardMonth).getTime() / 1000)
      const toSeconds = Math.floor(endOfMonth(dashboardMonth).getTime() / 1000)
      try {
        const snapshots = await Promise.allSettled(DASHBOARD_COURSE_SOURCES.map((source) => (
          getDocs(query(
            collection(db, source.collectionName),
            where('Created', '>=', fromSeconds),
            where('Created', '<=', toSeconds),
            orderBy('Created', 'desc'),
          ))
        )))
        const sourceResults = snapshots.map((result, index) => {
          const source = DASHBOARD_COURSE_SOURCES[index]
          if (result.status !== 'fulfilled') {
            console.log(`error loading ${monthKey} ${source.collectionName}`, result.reason)
            return { source, docs: [] }
          }

          return { source, docs: getFirebaseDocs(result.value) }
        })
        const { rows, classes } = buildDashboardCourseData(sourceResults, { role: userData?.role, trainerId: userData?.trainerId })
        setDashboardMonthRows(rows)
        setDashboardMonthClasses(classes)
      } catch (error) {
        console.log('error loading dashboard month', error)
        monthDataLoadRef.current = { userKey: '', monthKey: '' }
      }
    }

    loadMonth()
  }, [currentTab, dashboardMonth, userData, classEditVersion])

  const signOutUser = async () => {
    await auth.signOut();
  }


  let dates = []

  const combinedSidebarRows = useMemo(() => focusedPipeline ? dashboardCourseRows.filter(row => row.dashboardCourseTab === currentTab) : ([
    ...eois.map((row) => ({ ...row, submissionType: 'eoi' })),
    ...declarations.map((row) => ({ ...row, submissionType: 'declaration' })),
  ]), [declarations, eois, focusedPipeline, dashboardCourseRows, currentTab])

  const getCurrentActiveRow = () => {
    if (enableMultiSelect) {
      return selectedRows.map(row => row.id)
    } else {
      if (selectedSubmissionType === 'eoi' && currentEoi && currentEoi.id) {
        return [currentEoi.id]
      }
      else if (selectedSubmissionType === 'declaration' && currentDeclaration && currentDeclaration.id) {
        return [currentDeclaration.id]
      }
      return []
    }
  }


  const toggleRow = row => {
    if (enableMultiSelect) {
      if (selectedRows.find(el => el.id === row.id)) {
        setSelectedRows(selectedRows.filter(el => el.id !== row.id))
      } else {
        const existingSubmissionType = selectedRows[0]?.submissionType
        if (existingSubmissionType && existingSubmissionType !== row.submissionType) {
          showWarningMessage(`Clear current selection to choose ${row.submissionType === 'eoi' ? 'EOI' : 'Declaration'} rows.`)
          return
        }
        setSelectedRows([...selectedRows, row])
      }
    } else {
      const nextSubmissionType = row.submissionType || 'eoi'
      setSelectedSubmissionType(nextSubmissionType)
      if (nextSubmissionType === 'eoi') {
        dispatch(setCurrenDeclaration())
        dispatch(setCurrenEoi(row))
      } else {
        dispatch(setCurrenEoi())
        dispatch(setCurrenDeclaration(row))
      }
    }
  }

  const handleStageCellClick = (record) => {
    if (!record) {
      return
    }

    toggleRow(record)
    if (!enableMultiSelect) {
      setIsDeclarationEditing(false)
      setShowStudentDetailsPopup(true)
    }
  }

  // useEffect(() => {
  //   if (currentQldAssessment) {
  //     setAssessmentDate(currentQldAssessment.createdDate)
  //   }
  // }, [currentQldAssessment])

  const triggerDownloadUrl = (url) => {
    window.open(`${downloadFileUrl}?url=${url}`)
  }


  const copyTextToClipboard = (id, message) => {
    var copyText = document.getElementById(id)
    copyText.select()
    copyText.setSelectionRange(0, 99999)
    navigator.clipboard.writeText(copyText.value);

    showSuccessMessage(`${id.includes('eoi') ? 'EOI' : 'Declaration'} Link copied for ${message}, user: ${userData.trainerId.toUpperCase()}`)

    // if (id === 'assessment') {
    // } else if (id === 'review') {
    // } else if (id === 'qld-assessment') {
    // } else {
    // }
  }

  const searchFilter = row => {
    if (!search) {
      return true
    }

    const searchTerm = search ? search.toLowerCase() : ''
    const firstName = String(row.firstName || row.data?.firstName || '').toLowerCase()
    const lastName = String(row.lastName || row.data?.lastName || '').toLowerCase()
    const email = String(row.email || row.data?.email || '').toLowerCase()
    const dob = String(row.dob || row.data?.dob || '').toLowerCase()

    return firstName.includes(searchTerm)
      || lastName.includes(searchTerm)
      || email.includes(searchTerm)
      || dob.includes(searchTerm)
    // if (currentTab === tabs[1]) {
    // } else if (currentTab === tabs[2]) {
    //   return row.studentName.toLowerCase().includes(searchTerm)
    // } else {
    //   return row.firstName.toLowerCase().includes(searchTerm) || row.lastName.toLowerCase().includes(searchTerm) || row.email.toLowerCase().includes(searchTerm) || row.dob.toLowerCase().includes(searchTerm)
    // }
  }

  const buildStudentRosterKey = getClassStudentKey

  const combinedCourseRows = useMemo(() => {
    const seen = new Set()
    return [...dashboardCourseRows, ...dashboardMonthRows].filter((row) => {
      const key = dashboardCourseRowKey(row)
      if (seen.has(key)) return false
      seen.add(key)
      return true
    })
  }, [dashboardCourseRows, dashboardMonthRows])

  const allAdminClassGroups = useMemo(() => (
    DASHBOARD_TABS.flatMap((courseTab) => (
      buildAdminClassGroups({
        rows: combinedCourseRows.filter((row) => row.dashboardCourseTab === courseTab),
        classes: adminClasses.filter((courseClass) => courseClass.courseTypeKey === getAdminClassTypeKeyForTab(courseTab)),
        currentTab: courseTab,
      })
    ))
  ), [adminClasses, combinedCourseRows])

  const classGroups = useMemo(() => (
    buildAdminClassGroups({
      rows: combinedSidebarRows,
      classes: adminClasses,
      currentTab,
    })
  ), [adminClasses, combinedSidebarRows, currentTab])

  const visibleClassGroups = useMemo(() => (
    (isAdminUser && classCourseFilter === '__all__' ? allAdminClassGroups : classGroups).filter((classGroup) => {
      if (isAdminUser && filter?.value && String(classGroup.trainerId || '').trim().toLowerCase() !== String(filter.value).trim().toLowerCase()) return false
      if (!classDateFilter) return true
      const classDate = new Date(classGroup.scheduledDate || classGroup.scheduledDateKey || '')
      return !Number.isNaN(classDate.getTime()) && format(classDate, 'yyyy-MM-dd') === classDateFilter
    })
  ), [allAdminClassGroups, classCourseFilter, classDateFilter, classGroups, filter, isAdminUser])

  const classResultsPageCount = Math.max(1, Math.ceil(visibleClassGroups.length / 20))
  const pagedClassGroups = useMemo(() => (
    visibleClassGroups.slice((classResultsPage - 1) * 20, classResultsPage * 20)
  ), [classResultsPage, visibleClassGroups])

  useEffect(() => {
    setClassResultsPage((page) => Math.min(page, classResultsPageCount))
  }, [classResultsPageCount])

  useEffect(() => {
    setClassResultsPage(1)
  }, [classCourseFilter, classDateFilter, filter])

  const dashboardClassGroups = useMemo(() => (
    allAdminClassGroups.filter((group) => group.courseTypeKey !== getAdminClassTypeKeyForTab(qldTab))
  ), [allAdminClassGroups, qldTab])

  const dashboardLodgementClasses = useMemo(() => {
    const todayKey = format(new Date(), 'yyyy-MM-dd')

    return dashboardClassGroups
      .map((group) => {
        const eoiRows = (group.rows || []).filter((row) => (row.submissionType || 'eoi') === 'eoi')
        const completedCount = eoiRows.filter((row) => row.completed).length
        const readyCount = eoiRows.filter((row) => row.verified && !row.completed).length
        const dateKey = group.scheduledDateKey || format(new Date(group.scheduledDate || group.createdAt || new Date()), 'yyyy-MM-dd')
        return {
          ...group,
          eoiCount: eoiRows.length,
          completedCount,
          readyCount,
          dateKey,
        }
      })
      .filter((group) => group.eoiCount > 0 && group.completedCount < group.eoiCount && group.dateKey <= todayKey)
      .sort((left, right) => new Date(left.scheduledDate || left.dateKey).getTime() - new Date(right.scheduledDate || right.dateKey).getTime())
  }, [dashboardClassGroups])

  const studentDirectoryRows = useMemo(() => {
    const rows = dashboardClassGroups.flatMap((group) => {
      const rowMap = (group.rows || []).reduce((acc, row) => {
        const key = buildStudentRosterKey(row, group.id)
        const existing = acc[key] || { eoi: null, declaration: null }
        existing[row.submissionType || 'eoi'] = row
        acc[key] = existing
        return acc
      }, {})

      return Object.values(rowMap).map((record) => {
        const sourceRow = record.eoi || record.declaration || {}
        const fullName = [sourceRow.firstName || sourceRow.data?.firstName || '', sourceRow.lastName || sourceRow.data?.lastName || '']
          .filter(Boolean)
          .join(' ')
          .trim() || 'Unnamed student'
        const trainerName = group.trainerName || trainers.find((trainer) => trainer.trainerId === group.trainerId)?.name || group.trainerId || 'Unassigned trainer'
        const statementNumbers = [
          record.eoi?.statementTraningNumber,
          record.eoi?.data?.statementTraningNumber,
          record.eoi?.statementTraningNumberTwo,
          record.eoi?.data?.statementTraningNumberTwo,
          record.declaration?.statementTraningNumber,
          record.declaration?.data?.statementTraningNumber,
          record.declaration?.statementTraningNumberTwo,
          record.declaration?.data?.statementTraningNumberTwo,
        ].filter(Boolean).join(' ')

        return {
          id: buildStudentRosterKey(sourceRow, group.id),
          studentId: sourceRow.studentId || sourceRow.studentID || sourceRow.data?.studentId || sourceRow.data?.studentID || sourceRow.id || '',
          fullName,
          dob: sourceRow.dob || sourceRow.data?.dob || '',
          email: sourceRow.email || sourceRow.data?.email || '',
          statementNumbers,
          courseLabel: DASHBOARD_COURSE_LABELS[group.courseTypeKey] || group.courseLabel || group.dashboardCourseTab || 'Course',
          trainerName,
          scheduledDate: group.scheduledDate,
          scheduledDateKey: group.scheduledDateKey,
          group,
          eoi: record.eoi,
          declaration: record.declaration,
          firstName: sourceRow.firstName || sourceRow.data?.firstName || '',
          middleName: sourceRow.middleName || sourceRow.data?.middleName || '',
          lastName: sourceRow.lastName || sourceRow.data?.lastName || '',
          address: sourceRow.address || sourceRow.data?.address || sourceRow.addressFirstPage || sourceRow.data?.addressFirstPage || '',
          postalAddress: sourceRow.postalAddress || sourceRow.data?.postalAddress || '',
          mobile: sourceRow.mobile || sourceRow.data?.mobile || sourceRow.phone || sourceRow.data?.phone || '',
          assessmentPdf: record.eoi?.pdf || record.eoi?.data?.pdf || record.declaration?.pdf || record.declaration?.data?.pdf || '',
        }
      })
    })

    return rows
      .sort((left, right) => left.fullName.localeCompare(right.fullName, undefined, { sensitivity: 'base' }))
  }, [dashboardClassGroups])

  const dashboardStudentRows = useMemo(() => {
    const studentSearchTerm = dashboardStudentSearch.trim().toLowerCase()
    if (!studentSearchTerm) return []

    return studentDirectoryRows
      .filter((row) => {
        return [row.studentId, row.fullName, row.dob, row.email, row.statementNumbers, row.courseLabel, row.trainerName, row.mobile]
          .some((value) => String(value || '').toLowerCase().includes(studentSearchTerm))
      })
  }, [dashboardStudentSearch, studentDirectoryRows])

  const studentDirectoryResults = useMemo(() => {
    const searchTerm = studentDirectorySearch.trim().toLowerCase()
    if (!searchTerm) return []
    return studentDirectoryRows.filter((row) => (
      [row.fullName, row.dob, row.email, row.mobile, row.statementNumbers, row.courseLabel, row.trainerName]
        .some((value) => String(value || '').toLowerCase().includes(searchTerm))
    ))
  }, [studentDirectorySearch, studentDirectoryRows])

  const statsStudentRows = useMemo(() => allAdminClassGroups.flatMap((group) => {
    const uniqueStudents = (group.rows || []).reduce((items, row) => {
      const key = buildStudentRosterKey(row, group.id)
      if (!items[key] || (row.submissionType || 'eoi') === 'eoi') items[key] = row
      return items
    }, {})
    return Object.values(uniqueStudents).map((row) => ({
      date: new Date(group.scheduledDate || group.scheduledDateKey || row.createdAt || ''),
      courseLabel: DASHBOARD_COURSE_LABELS[group.courseTypeKey] || group.courseLabel || group.dashboardCourseTab || 'Course',
    }))
  }), [allAdminClassGroups])

  const statsMetrics = useMemo(() => {
    const selectedMonth = startOfMonth(statsMonth)
    const courseColour = (courseLabel) => {
      const label = String(courseLabel || '').toLowerCase()
      if (label.includes('implement')) return '#d0a500'
      if (label.includes('controller') || label.includes('control')) return '#3985bd'
      return '#7c4bb0'
    }
    const datedStudents = statsStudentRows.filter((student) => !Number.isNaN(student.date.getTime()))
    const monthSeries = Array.from({ length: selectedMonth.getMonth() + 1 }, (_, index) => {
      const date = startOfMonth(new Date(selectedMonth.getFullYear(), index, 1))
      const key = format(date, 'yyyy-MM')
      return { key, label: format(date, 'MMM'), count: datedStudents.filter((student) => format(student.date, 'yyyy-MM') === key).length }
    })
    const lastYearMonthSeries = Array.from({ length: selectedMonth.getMonth() + 1 }, (_, index) => {
      const date = startOfMonth(new Date(selectedMonth.getFullYear() - 1, index, 1))
      const key = format(date, 'yyyy-MM')
      return { key, label: format(date, 'MMM'), count: datedStudents.filter((student) => format(student.date, 'yyyy-MM') === key).length }
    })
    const currentMonthStart = selectedMonth
    const currentMonthEnd = endOfMonth(selectedMonth)
    const previousMonthStart = startOfMonth(addMonths(selectedMonth, -1))
    const previousMonthEnd = endOfMonth(previousMonthStart)
    const sameTimeLastYearStart = startOfMonth(addYears(selectedMonth, -1))
    const sameTimeLastYearEnd = endOfMonth(sameTimeLastYearStart)
    const courseBreakdown = Object.values(datedStudents.reduce((items, student) => {
      const label = student.courseLabel || 'Course'
      if (!items[label]) items[label] = { label, count: 0, colour: courseColour(label) }
      items[label].count += 1
      return items
    }, {})).sort((left, right) => right.count - left.count)
    const currentCount = datedStudents.filter((student) => student.date >= currentMonthStart && student.date <= currentMonthEnd).length
    const previousCount = datedStudents.filter((student) => student.date >= previousMonthStart && student.date <= previousMonthEnd).length
    const lastYearCount = datedStudents.filter((student) => student.date >= sameTimeLastYearStart && student.date <= sameTimeLastYearEnd).length
    const tableCourses = ['Traffic Controller', 'Traffic Implementer', 'QLD White Card', 'White Card']
    const courseTable = tableCourses.map((label) => {
      const rows = datedStudents.filter((student) => student.courseLabel === label)
      return {
        label: label === 'QLD White Card' ? 'White Card QLD' : label === 'White Card' ? 'White Card NSW' : label,
        current: rows.filter((student) => student.date >= currentMonthStart && student.date <= currentMonthEnd).length,
        lastYear: rows.filter((student) => student.date >= sameTimeLastYearStart && student.date <= sameTimeLastYearEnd).length,
        total: rows.length,
      }
    })
    return { monthSeries, lastYearMonthSeries, courseBreakdown, courseTable, currentCount, previousCount, lastYearCount, totalCount: datedStudents.length }
  }, [statsMonth, statsStudentRows])
  const activeStatsSeries = statsMetrics.monthSeries
  const statsSeriesMax = Math.max(1, ...activeStatsSeries.map((item) => item.count), ...statsMetrics.lastYearMonthSeries.map((item) => item.count))
  const statsGraphPoints = activeStatsSeries.map((item, index) => `${26 + (index * (488 / Math.max(1, activeStatsSeries.length - 1)))},${142 - ((item.count / statsSeriesMax) * 112)}`).join(' ')
  const statsLastYearGraphPoints = statsMetrics.lastYearMonthSeries.map((item, index) => `${26 + (index * (488 / Math.max(1, statsMetrics.lastYearMonthSeries.length - 1)))},${142 - ((item.count / statsSeriesMax) * 112)}`).join(' ')
  const statsCourseMax = Math.max(1, ...statsMetrics.courseTable.map((course) => Math.max(course.current, course.lastYear)))

  const studentResultsPageCount = Math.max(1, Math.ceil(studentDirectoryResults.length / 20))
  const pagedStudentDirectoryResults = useMemo(() => (
    studentDirectoryResults.slice((studentResultsPage - 1) * 20, studentResultsPage * 20)
  ), [studentDirectoryResults, studentResultsPage])

  useEffect(() => {
    setStudentResultsPage(1)
  }, [studentDirectorySearch])

  useEffect(() => {
    setStudentResultsPage((page) => Math.min(page, studentResultsPageCount))
  }, [studentResultsPageCount])

  const dashboardCalendarDays = useMemo(() => {
    const calendarStart = startOfWeek(startOfMonth(dashboardMonth), { weekStartsOn: 1 })
    const calendarEnd = endOfWeek(endOfMonth(dashboardMonth), { weekStartsOn: 1 })
    const numberOfDays = Math.round((calendarEnd.getTime() - calendarStart.getTime()) / 86400000) + 1
    return Array.from({ length: numberOfDays }, (_, index) => addDays(calendarStart, index))
  }, [dashboardMonth])

  const dashboardClassesByDate = useMemo(() => {
    const storedClassKeys = new Set(adminClasses.map(dashboardCalendarClassKey))
    const derivedClassKey = dashboardCalendarClassKey
    const seenDerived = new Set()
    const derivedClasses = [...dashboardMonthClasses, ...dashboardDerivedClasses].filter((courseClass) => {
      if (adminClasses.some(stored => (stored.id || stored.classId) === (courseClass.id || courseClass.classId))) return false
      const key = derivedClassKey(courseClass)
      if (storedClassKeys.has(key) || seenDerived.has(key)) return false
      seenDerived.add(key)
      return true
    })
    const calendarClasses = [...adminClasses, ...derivedClasses]

    return calendarClasses.reduce((classesByDate, courseClass) => {
    const scheduledDate = new Date(courseClass.scheduledDate || courseClass.createdAt || '')
    const dateKey = courseClass.scheduledDateKey || (Number.isNaN(scheduledDate.getTime()) ? '' : format(scheduledDate, 'yyyy-MM-dd'))
    if (!dateKey) return classesByDate
    classesByDate[dateKey] = [...(classesByDate[dateKey] || []), courseClass]
    return classesByDate
    }, {})
  }, [adminClasses, dashboardDerivedClasses, dashboardMonthClasses])

  const changeDashboardMonth = (updateMonth) => {
    calendarMonthTouchedRef.current = true
    setDashboardMonth((month) => startOfMonth(updateMonth(month)))
  }

  const openDashboardCourse = (courseClass) => {
    const courseTab = DASHBOARD_COURSE_TABS[courseClass.courseTypeKey]
    if (!courseTab) return

    const nextClassId = courseClass.id || courseClass.classId || ''
    setSelectedRows([])
    setCourseWorkspace('classes')
    // Clear any filter that would hide the class the trainer just clicked.
    if (isAdminUser) {
      setClassCourseFilter('__all__')
      setFilter(undefined)
      setClassDateFilter('')
    } else {
      setClassCourseFilter(courseTab)
      setClassDateFilter(courseClass.scheduledDateKey || '')
    }
    // The class stays selected while its course data loads, rather than being cleared.
    requestedClassIdRef.current = nextClassId
    setSelectedClassId(nextClassId)
    setShowClassResults(false)
    setCurrentTab(courseTab)
  }

  useEffect(() => {
    // Landing convenience only: once the month is chosen by hand, or jumped once,
    // the calendar stays where it is even if that month has no classes.
    if (currentTab !== 'Dashboard' || calendarMonthTouchedRef.current || Object.keys(dashboardClassesByDate).length === 0) {
      return
    }

    const visibleMonthKey = format(dashboardMonth, 'yyyy-MM')
    if (Object.keys(dashboardClassesByDate).some((dateKey) => dateKey.startsWith(visibleMonthKey))) {
      return
    }

    const today = startOfMonth(new Date())
    const scheduledDates = Object.keys(dashboardClassesByDate)
      .map((dateKey) => new Date(`${dateKey}T00:00:00`))
      .filter((date) => !Number.isNaN(date.getTime()))
      .sort((left, right) => left.getTime() - right.getTime())
    const nextScheduledDate = scheduledDates.find((date) => date >= today) || scheduledDates[scheduledDates.length - 1]
    if (nextScheduledDate) {
      calendarMonthTouchedRef.current = true
      setDashboardMonth(startOfMonth(nextScheduledDate))
    }
  }, [currentTab, dashboardClassesByDate, dashboardMonth])

  const selectedClassGroup = useMemo(
    () => {
      return visibleClassGroups.find((row) => row.id === selectedClassId) || null
    },
    [selectedClassId, visibleClassGroups]
  )

  const classFilteredSidebarRows = useMemo(() => {
    const rows = selectedClassGroup ? selectedClassGroup.rows : (isAdminUser ? combinedSidebarRows : [])
    return rows.filter((row) => row.id && searchFilter(row))
  }, [combinedSidebarRows, isAdminUser, search, selectedClassGroup])

  const studentRosterRows = useMemo(() => {
    const trafficCourseFlowMap = trafficCourseFlows.reduce((acc, flow) => {
      if (flow.trafficEoiId) {
        acc[flow.trafficEoiId] = flow
      }
      return acc
    }, {})

    const rosterMap = classFilteredSidebarRows.reduce((acc, row) => {
      const rowClass = selectedClassGroup || adminClasses.find(courseClass => matchesRowToAdminClass(row, courseClass, currentTab)) || deriveLegacyClassGroup(row, currentTab)
      const key = buildStudentRosterKey(row, rowClass.id)
      const fullName = [row.firstName || row.data?.firstName || '', row.lastName || row.data?.lastName || '']
        .filter(Boolean)
        .join(' ')
        .trim()

      const existing = acc[key] || {
        id: key,
        fullName,
        dob: row.dob || row.data?.dob || '',
        delivery: row.delivery || row.data?.delivery || '',
        trainerId: row.trainerId || row.data?.trainerId || '',
        eoi: null,
        declaration: null,
        trafficCourseFlow: null,
      }

      existing[row.submissionType || 'eoi'] = row
      if ((row.submissionType || 'eoi') === 'eoi' && trafficCourseFlowMap[row.id]) {
        existing.trafficCourseFlow = trafficCourseFlowMap[row.id]
      }
      acc[key] = existing
      return acc
    }, {})

    return Object.values(rosterMap).sort((left, right) => left.fullName.localeCompare(right.fullName, undefined, { sensitivity: 'base' }))
  }, [classFilteredSidebarRows, trafficCourseFlows, selectedClassGroup, adminClasses, currentTab])

  const trafficControllerPipelineTasks = useMemo(() => {
    if (!isTrafficCourse) {
      return []
    }

    const flowWithTasks = studentRosterRows.find((row) => (row.trafficCourseFlow?.tasks || []).length > 0)?.trafficCourseFlow
    const sourceTasks = trafficControllerTemplateTasks.length > 0 ? trafficControllerTemplateTasks : (flowWithTasks?.tasks || [])
    return (sourceTasks || []).filter((task) => !['Student instructions', 'Conditions of assessment'].includes(task.type))
      .filter((task) => task.type !== TRAINER_DECLARATION_TYPE)
      .concat((sourceTasks || []).filter((task) => task.type === TRAINER_DECLARATION_TYPE))
  }, [isTrafficCourse, studentRosterRows, trafficControllerTemplateTasks])

  const getTrafficBulkReleaseEligibleFlows = (task) => {
    if (!task?.id || task.type === TRAINER_DECLARATION_TYPE) {
      return []
    }

    return studentRosterRows
      .map((row) => row.trafficCourseFlow)
      .filter((flowDoc) => flowDoc?.id && getTaskState(flowDoc, task.id)?.status === 'locked')
  }

  const handleTrafficBulkRelease = async (task) => {
    const eligibleFlows = getTrafficBulkReleaseEligibleFlows(task)
    if (!task?.id || eligibleFlows.length === 0) {
      return
    }

    setBulkReleasingTrafficTaskId(task.id)
    try {
      await Promise.all(eligibleFlows.map((flowDoc) => (
        updateDoc(
          doc(db, 'trafficCourseFlows', flowDoc.id),
          new FieldPath('taskStates', String(task.id), 'status'),
          'available',
          'updatedAt',
          new Date().toISOString(),
        )
      )))
      showSuccessMessage(`${task.name || task.type || 'Assessment'} released for ${eligibleFlows.length} student${eligibleFlows.length === 1 ? '' : 's'}.`)
    } catch (releaseError) {
      clearPageMessage()
      showWarningMessage('The assessment could not be released. Please try again.')
      console.error('Unable to bulk release traffic assessment', releaseError)
    } finally {
      setBulkReleasingTrafficTaskId('')
    }
  }

  // Only assessed sections can be bulk marked; instructions and declarations have nothing to mark.
  const isMarkableTrafficTask = (task) => ['Activity', 'Theory Questions'].includes(task?.type)

  const getTrafficMarkRows = (task) => {
    if (!isMarkableTrafficTask(task)) {
      return []
    }

    return studentRosterRows.reduce((acc, row) => {
      const flowDoc = row.trafficCourseFlow
      const flowTask = flowDoc?.id ? getFlowTaskById(flowDoc, task.id) : null
      if (!flowTask) {
        return acc
      }

      const state = getTaskState(flowDoc, task.id)
      return [...acc, {
        row,
        flowDoc,
        flowTask,
        state,
        eligible: state?.status === 'submitted' && !state?.priorCompletion,
      }]
    }, [])
  }

  const buildTrafficMarkUpdate = (markRow, task, mark) => {
    const questionMarks = {}
    const checklistMarks = {}

    if (task.type === 'Activity') {
      getActivityChecklist(markRow.flowTask)
        .filter((entry) => !['guide', 'subsection'].includes(entry.kind || 'criterion'))
        .forEach((entry) => { checklistMarks[entry.id] = mark })
    } else {
      getTheoryReviewTargets(markRow.flowTask.questions || []).forEach((target) => { questionMarks[target.id] = mark })
    }

    const existingReview = markRow.flowDoc.responses?.[task.id]?.assessorReview || {}
    return {
      assessorReview: {
        questionMarks: { ...(existingReview.questionMarks || {}), ...questionMarks },
        checklistMarks: { ...(existingReview.checklistMarks || {}), ...checklistMarks },
      },
      // Only a fully satisfactory section completes; NYC keeps it submitted for another look.
      status: mark === 'C' ? 'completed' : 'submitted',
    }
  }

  const openTrafficMarkPopup = (task) => {
    setMarkTask(task)
    setMarkDraft({})
  }

  const handleSaveTrafficMarks = async () => {
    const markRows = getTrafficMarkRows(markTask).filter((markRow) => markRow.eligible && markDraft[markRow.row.id])
    if (!markTask?.id || markRows.length === 0) {
      return
    }

    setSavingTrafficMarks(true)
    try {
      const now = new Date().toISOString()
      await Promise.all(markRows.map((markRow) => {
        const update = buildTrafficMarkUpdate(markRow, markTask, markDraft[markRow.row.id])
        return updateDoc(
          doc(db, 'trafficCourseFlows', markRow.flowDoc.id),
          new FieldPath('responses', String(markTask.id), 'assessorReview'), update.assessorReview,
          new FieldPath('taskStates', String(markTask.id), 'status'), update.status,
          new FieldPath('taskStates', String(markTask.id), 'completedAt'), update.status === 'completed' ? now : '',
          'updatedAt', now,
        )
      }))
      showSuccessMessage(`${markTask.name || markTask.type || 'Assessment'} marked for ${markRows.length} student${markRows.length === 1 ? '' : 's'}.`)
      setMarkTask(null)
      setMarkDraft({})
    } catch (markError) {
      clearPageMessage()
      showWarningMessage('The marks could not be saved. Please try again.')
      console.error('Unable to bulk mark traffic assessment', markError)
    } finally {
      setSavingTrafficMarks(false)
    }
  }

  const downloadableEoiRows = studentRosterRows.filter((row) => row.eoi?.pdf)

  const openDownloadEoiPopup = () => {
    setDownloadEoiIds([])
    setShowDownloadEoiPopup(true)
  }

  const toggleDownloadEoi = (eoiId) => {
    setDownloadEoiIds((current) => current.includes(eoiId)
      ? current.filter((id) => id !== eoiId)
      : [...current, eoiId])
  }

  const handleDownloadSelectedEois = () => {
    downloadableEoiRows
      .filter((row) => downloadEoiIds.includes(row.eoi.id))
      .forEach((row) => triggerDownloadUrl(row.eoi.pdf))
    setShowDownloadEoiPopup(false)
    setDownloadEoiIds([])
  }

  const selectedRecord = selectedSubmissionType === 'declaration' ? currentDeclaration : currentEoi
  const selectedDatabase = selectedSubmissionType === 'declaration'
    ? currentCourseConfig?.declarationDb
    : currentCourseConfig?.eoiDb
  const selectedTrafficTask = selectedTrafficFlowStage ? getFlowTaskById(selectedTrafficFlowStage.flowDoc, selectedTrafficFlowStage.taskId) : null
  const selectedStudentName = selectedSubmissionType === 'builderStage'
    ? `${selectedTrafficFlowStage?.flowDoc?.firstName || ''} ${selectedTrafficFlowStage?.flowDoc?.lastName || ''}`.trim()
    : `${selectedRecord?.firstName || selectedRecord?.data?.firstName || ''} ${selectedRecord?.lastName || selectedRecord?.data?.lastName || ''}`.trim()

  const getDatabaseForSubmissionType = (submissionType = 'eoi') => (
    submissionType === 'declaration'
      ? currentCourseConfig?.declarationDb
      : currentCourseConfig?.eoiDb
  )

  useEffect(() => {
    if (currentTab === qldTab) {
      return
    }

    if (selectedClassId && visibleClassGroups.some((row) => row.id === selectedClassId)) {
      if (requestedClassIdRef.current === selectedClassId) {
        requestedClassIdRef.current = ''
      }
      return
    }

    // A class opened from the calendar or restored on refresh survives data loading.
    if (requestedClassIdRef.current && requestedClassIdRef.current === selectedClassId) {
      return
    }

    const trainerFiltersReady = isAdminUser || (classCourseFilter && classDateFilter)
    if (!trainerFiltersReady || !visibleClassGroups.length || selectedClassId) {
      setSelectedClassId('')
    }
  }, [classCourseFilter, classDateFilter, currentTab, isAdminUser, qldTab, selectedClassId, visibleClassGroups])

  useEffect(() => {
    if (currentTab === qldTab) {
      return
    }

    dispatch(setCurrenEoi())
    dispatch(setCurrenDeclaration())
    setSelectedSubmissionType('eoi')
    setSelectedRows([])
    setSelectedTrafficFlowStage(null)
    setSearch('')
  }, [currentTab, dispatch, qldTab, selectedClassId])

  const handleTrafficFlowStageClick = (flowDoc, taskId) => {
    if (!flowDoc || !taskId) {
      return
    }

    setSelectedTrafficFlowStage({ flowDoc, taskId })
    setSelectedSubmissionType('builderStage')
    setIsDeclarationEditing(false)
    setShowStudentDetailsPopup(true)
  }

  const handleTrafficFlowUpdated = (updatedFlowDoc) => {
    if (!updatedFlowDoc?.id) {
      return
    }

    setTrafficCourseFlows((current) => current.map((flow) => flow.id === updatedFlowDoc.id ? updatedFlowDoc : flow))
    setSelectedTrafficFlowStage((current) => (
      current?.flowDoc?.id === updatedFlowDoc.id
        ? { ...current, flowDoc: updatedFlowDoc }
        : current
    ))
  }

  const toggleLodgeConfirmation = (rowId) => {
    setLodgeConfirmations(current => ({
      ...current,
      [rowId]: !current[rowId]
    }))
  }

  const allLodgeRowsConfirmed = selectedRows.length > 0 && selectedRows.every(row => !!lodgeConfirmations[row.id])

  const getStudentSortName = (row) => (
    [row.firstName || row.data?.firstName || '', row.data?.otherName || '', row.lastName || row.data?.lastName || '']
      .join(' ')
      .trim()
      .toLowerCase()
  )

  const sortedSelectedRows = [...selectedRows].sort((a, b) => (
    getStudentSortName(a).localeCompare(getStudentSortName(b), undefined, { sensitivity: 'base' })
  ))

  const renderSelectedStudentsTable = () => (
    <div className="lodgeStudentsTableWrap">
      <table>
        <thead>
          <tr>
            <th>First Name</th>
            <th>Other Name</th>
            <th>Last Name</th>
            <th>Unit/Property number</th>
            <th>Street Name</th>
            <th>Suburb</th>
            <th>State</th>
            <th>Postcode</th>
            <th>Date of Birth</th>
            <th>Check</th>
          </tr>
        </thead>
        <tbody>
          {sortedSelectedRows.map((row) => (
            <tr key={row.id}>
              <td>{row.firstName || ''}</td>
              <td>{row.data?.otherName || ''}</td>
              <td>{row.lastName || ''}</td>
              <td>{row.data?.streetNumberPostal || ''}</td>
              <td>{row.data?.streetNamePostal || ''}</td>
              <td>{row.data?.suburbPostal || ''}</td>
              <td>{row.data?.statePostal || ''}</td>
              <td>{row.data?.postcodePostal || ''}</td>
              <td>{row.dob || row.data?.dob || ''}</td>
              <td>
                <button
                  type='button'
                  className={`detailConfirmationTick ${lodgeConfirmations[row.id] ? 'checked' : ''}`}
                  onClick={() => toggleLodgeConfirmation(row.id)}
                  aria-label={`${lodgeConfirmations[row.id] ? 'Unconfirm' : 'Confirm'} details for ${getStudentSortName(row)}`}
                >
                  ✓
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )

  const handleGenerateReport = async () => {
    setLoading(true)
    showLoadingMessage('Generating Report')

    try {

      // 'dec-trafficControl' : 'dec-trafficImplementation',


      const resp = await axios.post('https://australia-southeast1-upskillinstitute-au.cloudfunctions.net/generateQI', {
        // const resp = await axios.post('http://127.0.0.1:5001/upskillinstitute-au/australia-southeast1/generateQI', {
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        database: qiReportCourse === 'Traffic Control' ? 'dec-trafficControl' : 'dec-trafficImplementation'
      }, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      setLoading(false)
      setShowGenerateReport(false)
      showSuccessMessage('Generated Report!')

      const csvData = resp.data.map(r => r.join(', ')).join('\r\n')
      console.log('csvData', csvData)
      downloadBlob(csvData, 'QI Report.csv', 'text/csv;charset=utf-8;')
    } catch (e) {
      clearPageMessage()
      console.error('e report', e)
      toast.error('Error generating Report!', { position: 'top-center' })
      setLoading(false)
    }
  }

  const handleCreateCourse = async () => {
    setLoading(true)
    showLoadingMessage('Creating Course')

    try {
      const matchingCourse = createCourseOptions.find((row) => row.name === courseType.value)
      const matchingTrainer = trainers.find((row) => row.name.toLowerCase() === String(courseTrainer.value || '').toLowerCase())

      const resp = await axios.post('https://australia-southeast1-upskillinstitute-au.cloudfunctions.net/createCoursesRTO', {
        // const resp = await axios.post('http://127.0.0.1:5001/upskillinstitute-au/australia-southeast1/createCoursesRTO', {
        username,
        password,
        course: courseType.value,
        trainer: courseTrainer.value,
        dates: courseStartDates.map(r => format(r, 'dd/MM/yyyy'))
      }, {
        timeout: 60 * 60 * 1000,
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })

      if (matchingCourse) {
        await Promise.all(
          courseStartDates.map((date) => {
            const classDoc = buildAdminClassDocument({
              courseName: matchingCourse.name,
              // Exact course identity, and whether this is a course day or its assessment.
              courseType: matchingCourse.courseType || '',
              course: matchingCourse.course || '',
              trainerId: matchingTrainer?.trainerId || '',
              trainerName: matchingTrainer?.name || courseTrainer.value || '',
              scheduledDate: date,
              startTime: matchingCourse.start || '',
              endTime: matchingCourse.end || '',
              delivery: matchingCourse.onlineLink ? 'online' : 'classroom',
              location: matchingCourse.location || '',
              onlineLink: matchingCourse.onlineLink || '',
              source: 'rto-course-create',
            })

            return setDoc(doc(db, 'adminClasses', classDoc.classId), classDoc)
          })
        )
      }

      setLoading(false)
      setShowCreateCourses(false)
      showSuccessMessage('Course created successfully')
      fetchAdminClasses()


    } catch (e) {
      clearPageMessage()
      console.error('e report', e)
      showWarningMessage('Course could not be created. Please check the details and try again.')
      setLoading(false)
    }
  }

  const handleLodgeEoi = async () => {
    setLoading(true)
    showLoadingMessage('Lodging Students')

    try {

      const resp = await axios.post('https://australia-southeast1-upskillinstitute-au.cloudfunctions.net/automateRTO', {
        // const resp = await axios.post('http://127.0.0.1:5001/upskillinstitute-au/australia-southeast1/automateRTO', {
        rows: selectedRows,
        courseNo,
        username,
        password,
        database: currentCourseConfig?.eoiDb,
      }, {
        timeout: 60 * 60 * 1000,
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      setLoading(false)
      setSelectedRows([])
      setShowLodgePopup(false)
      showSuccessMessage(`Lodged EOIs for ${resp.data.data.completedStudents.length} Students! Failed Students: ${resp.data.data.failedStudents.length}. Unmatched: ${resp.data.data.unmatchedCount} `)

    } catch (e) {
      clearPageMessage()
      console.error('e lodge eoi', e)
      setSelectedRows([])
      setShowLodgePopup(false)
      toast.error('Error lodging EOI! Pls check sidebar for completed students if any.', { position: 'top-center' })
      setLoading(false)
    }
    fetchEoi()
  }

  const handleLodgeTrafficEoi = async () => {
    setLoading(true)
    showLoadingMessage('Lodging Traffic Students')

    try {

      const resp = await axios.post('https://australia-southeast1-upskillinstitute-au.cloudfunctions.net/automateTrafficRTO', {
        // const resp = await axios.post('http://127.0.0.1:5001/upskillinstitute-au/australia-southeast1/automateTrafficRTO', {
        rows: selectedRows,
        courseNo,
        username,
        password,
        courseNoAlternate,
        database: currentCourseConfig?.eoiDb,
      }, {
        timeout: 60 * 60 * 1000,
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      setLoading(false)
      setSelectedRows([])
      setShowLodgeTrafficPopup(false)
      showSuccessMessage(`Lodged EOIs for ${resp.data.data.completedStudents.length} Students! Failed Students: ${resp.data.data.failedStudents.length}. Unmatched: ${resp.data.data.unmatchedCount} `)

    } catch (e) {
      clearPageMessage()
      console.error('e lodge eoi', e)
      setSelectedRows([])
      setShowLodgeTrafficPopup(false)
      toast.error('Error lodging Traffic EOI! Pls check sidebar for completed students if any.', { position: 'top-center' })
      setLoading(false)
    }

    // Fetch relevant eois based on current tab later.
    // fetchEoi()
    fetchTrafficEoi(false, currentCourseConfig?.eoiDb)

  }


  const downloadBlob = (content, filename, contentType) => {
    // Create a blob
    var blob = new Blob([content], { type: contentType });
    var url = URL.createObjectURL(blob);

    // Create a link to download it
    var pom = document.createElement('a');
    pom.href = url;
    pom.setAttribute('download', filename);
    pom.click();
  }

  const escapeCsvValue = (value) => {
    const normalized = value === undefined || value === null ? '' : String(value)
    return `"${normalized.replace(/"/g, '""')}"`
  }

  const buildCsv = (rows) => rows.map((row) => row.map(escapeCsvValue).join(',')).join('\r\n')

  const getReportDatabase = () => (
    reportCourse?.value === 'White Card EOI' ? 'eoi'
      : reportCourse?.value === 'Traffic Control EOI' ? 'trafficControl'
        : reportCourse?.value === 'Traffic Implement EOI' ? 'trafficImplementation'
          : ''
  )

  const getReportCourseLabel = (database) => (
    database === 'eoi' ? 'White Card EOI'
      : database === 'trafficControl' ? 'Traffic Control EOI'
        : 'Traffic Implement EOI'
  )

  const getReportStudentName = (row) => (
    [row.firstName || row.data?.firstName || '', row.data?.otherName || '', row.lastName || row.data?.lastName || '']
      .filter(Boolean)
      .join(' ')
  )

  const getReportDateRange = (selectedStartDate, selectedEndDate) => {
    const startYear = selectedStartDate.getFullYear()
    const startMonth = selectedStartDate.getMonth()
    const startDay = selectedStartDate.getDate()
    const endYear = selectedEndDate.getFullYear()
    const endMonth = selectedEndDate.getMonth()
    const endDay = selectedEndDate.getDate()

    const start = new Date(startYear, startMonth, startDay, 0, 0, 0, 0)
    const endExclusive = new Date(endYear, endMonth, endDay + 1, 0, 0, 0, 0)

    return {
      startMs: start.getTime(),
      endExclusiveMs: endExclusive.getTime(),
    }
  }

  const fetchReportRows = async () => {
    const database = getReportDatabase()
    const selectedTrainer = trainers.find((trainer) => trainer.name === reportTrainer?.value)

    let constraints = [orderBy('Created', 'desc')]

    if (selectedTrainer) {
      constraints = [
        where('data.trainerId', '==', selectedTrainer.trainerId),
        ...constraints,
      ]
    }

    const snapshot = await getDocs(query(collection(db, database), ...constraints))
    return getFirebaseDocs(snapshot)
  }

  const handleGenerateAuditReport = async () => {
    if (!reportCourse?.value || !reportType?.value) {
      toast.error('Choose course and report type.', { position: 'top-center' })
      return
    }

    if (!reportStartDate || !reportEndDate) {
      toast.error('Choose start date and end date.', { position: 'top-center' })
      return
    }

    if (reportEndDate < reportStartDate) {
      toast.error('End date must be on or after start date.', { position: 'top-center' })
      return
    }

    try {
      setLoading(true)
      showLoadingMessage('Generating Audit Report')

      const database = getReportDatabase()
      const courseLabel = getReportCourseLabel(database)
      const rows = await fetchReportRows()
      const { startMs, endExclusiveMs } = getReportDateRange(reportStartDate, reportEndDate)
      const isTimestampInRange = (value) => {
        const time = new Date(value).getTime()
        return !Number.isNaN(time) && time >= startMs && time < endExclusiveMs
      }
      let csvRows = []

      if (reportType?.value === 'Verification report') {
        csvRows = [[
          'Course',
          'Student Name',
          'Trainer Assigned',
          'Verified By',
          'Field',
          'Action',
          'Value',
          'Verified At',
        ]]

        rows.forEach((row) => {
          const trainerFields = row.data?.studentDetailVerification?.trainer?.fields || {}
          const assignedTrainer = trainers.find((trainer) => trainer.trainerId === row.trainerId || trainer.trainerId === row.data?.trainerId)?.name || row.data?.trainerId || ''
          const studentName = getReportStudentName(row)

          Object.values(trainerFields).forEach((fieldData) => {
            ; (fieldData.history || []).forEach((historyItem) => {
              if (!isTimestampInRange(historyItem.at)) {
                return
              }

              csvRows.push([
                courseLabel,
                studentName,
                assignedTrainer,
                historyItem.actorName || fieldData.checkedBy || '',
                fieldData.label || '',
                historyItem.action || '',
                historyItem.value ?? fieldData.value ?? '',
                historyItem.at ? format(new Date(historyItem.at), 'dd/MM/yyyy hh:mm a') : '',
              ])
            })
          })
        })
      } else {
        csvRows = [[
          'Course',
          'Student Name',
          'Trainer Assigned',
          'Changed By',
          'Field',
          'From',
          'To',
          'Changed At',
        ]]

        rows.forEach((row) => {
          const assignedTrainer = trainers.find((trainer) => trainer.trainerId === row.trainerId || trainer.trainerId === row.data?.trainerId)?.name || row.data?.trainerId || ''
          const studentName = getReportStudentName(row)

            ; (row.data?.changeAuditHistory || []).forEach((event) => {
              if (!isTimestampInRange(event.at)) {
                return
              }

              ; (event.changes || []).forEach((change) => {
                csvRows.push([
                  courseLabel,
                  studentName,
                  assignedTrainer,
                  event.actorName || '',
                  change.label || change.fieldKey || '',
                  change.fromValue || '',
                  change.toValue || '',
                  event.at ? format(new Date(event.at), 'dd/MM/yyyy hh:mm a') : '',
                ])
              })
            })
        })
      }

      if (csvRows.length === 1) {
        showWarningMessage('No matching records found for that report.')
        setLoading(false)
        return
      }

      const filename = `${reportType?.value === 'Verification report' ? 'Verification' : 'Changes'} Report ${courseLabel} ${format(new Date(), 'dd-MM-yyyy')}.csv`
      downloadBlob(buildCsv(csvRows), filename, 'text/csv;charset=utf-8;')
      setShowReportsPopup(false)
      showSuccessMessage('Report generated.')
      setLoading(false)
    } catch (e) {
      clearPageMessage()
      console.error('e audit report', e)
      toast.error('Error generating report!', { position: 'top-center' })
      setLoading(false)
    }
  }

  const renderDate = date => {
    const formattedDate = format(new Date(date), 'dd MMM yyyy')
    if (dates.includes(formattedDate)) {
      return <></>
    }
    dates.push(formattedDate)

    return <h4 style={{ margin: '0', background: 'white', width: 'calc(100% + 16px)', marginLeft: '-20px', marginTop: '-10px', padding: '10px 0', paddingLeft: '14px' }}>{formattedDate}</h4>
  }

  const toggleCompleted = async (row) => {
    const database = enableMultiSelect
      ? selectedDatabase
      : getDatabaseForSubmissionType(row?.submissionType || selectedSubmissionType)

    showLoadingMessage(row.completed ? 'Marking Record as Incomplete' : 'Marking Record as Complete')

    try {
      setLoading(true)
      const resp = await axios.post('https://australia-southeast1-upskillinstitute-au.cloudfunctions.net/toggleRowComplete', {
        // const resp = await axios.post('http://127.0.0.1:5001/upskillinstitute-au/australia-southeast1/toggleRowComplete', {
        rows: enableMultiSelect ? selectedRows : [row],
        database
      }, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      setLoading(false)
      setShowGenerateReport(false)
      setSelectedRows([])
      setEnableMultiSelect(false)
      showSuccessMessage('Toggled Complete Status!')

    } catch (e) {
      clearPageMessage()
      console.error('e report', e)
      toast.error('Error toggling complete status!', { position: 'top-center' })
      setLoading(false)
    }


    performFetch(false)
  }

  const toggleVerified = async (row) => {
    const submissionType = row?.submissionType || selectedSubmissionType
    const requiresTrainerVerification = submissionType === 'eoi'

    if (requiresTrainerVerification && !isTrainerVerificationComplete(row.data)) {
      toast.error('Complete all trainer detail checks first.', { position: 'top-center' })
      return
    }

    const database = enableMultiSelect
      ? selectedDatabase
      : getDatabaseForSubmissionType(submissionType)

    const isMarkingVerified = !row.verified
    showLoadingMessage(isMarkingVerified ? 'Marking Student as Satisfactory' : 'Marking Student as Cannot proceed')

    try {
      setLoading(true)
      const resp = await axios.post('https://australia-southeast1-upskillinstitute-au.cloudfunctions.net/toggleRowVerified', {
        // const resp = await axios.post('http://127.0.0.1:5001/upskillinstitute-au/australia-southeast1/toggleRowVerified', {
        rows: enableMultiSelect ? selectedRows : [row],
        database
      }, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      setLoading(false)
      setShowGenerateReport(false)
      setSelectedRows([])
      setEnableMultiSelect(false)
      if (!enableMultiSelect) {
        const updatedRow = { ...row, verified: !row.verified }
        if (submissionType === 'eoi') {
          dispatch(setCurrenEoi(updatedRow))
        } else {
          dispatch(setCurrenDeclaration(updatedRow))
        }
      }
      if (!enableMultiSelect) {
        const isNowVerified = !row.verified
        setVerificationStatusMessage({
          verified: isNowVerified,
          text: isNowVerified ? 'Student ID marked as Satisfactory' : 'Student ID marked as Cannot proceed',
        })
        window.setTimeout(() => setVerificationStatusMessage(null), 2200)
      }
      showSuccessMessage(isMarkingVerified ? 'Student marked as Satisfactory' : 'Student marked as Cannot proceed')

    } catch (e) {
      clearPageMessage()
      console.error('e report', e)
      toast.error('Error updating assessment status!', { position: 'top-center' })
      setLoading(false)
    }


    performFetch(false)
  }

  // const isRto = () => userData && userData.role === 'rto'


  return <div style={{ padding: '10px' }}>
    <Header />

    {userData && <div style={{ display: 'none' }}>
      <input style={{ display: 'none' }} readOnly id='eoi-online' value={`https://upskillinstitute-au.firebaseapp.com/?trainerId=${userData.trainerId}&delivery=online`} />
      <input style={{ display: 'none' }} readOnly id='eoi-classroom' value={`https://upskillinstitute-au.firebaseapp.com/?trainerId=${userData.trainerId}&delivery=classroom`} />
      {/* <input style={{ display: 'none' }} readOnly id='eoi-traffic-online' value={`https://upskillinstitute-au.firebaseapp.com/trafficControl?trainerId=${userData.trainerId}&delivery=online`} /> */}
      <input style={{ display: 'none' }} readOnly id='eoi-traffic-classroom' value={`https://upskillinstitute-au.firebaseapp.com/trafficControl?trainerId=${userData.trainerId}&delivery=classroom`} />
      {/* <input style={{ display: 'none' }} readOnly id='eoi-traffic-implement-online' value={`https://upskillinstitute-au.firebaseapp.com/trafficImplementation?trainerId=${userData.trainerId}&delivery=online`} /> */}
      <input style={{ display: 'none' }} readOnly id='eoi-traffic-implement-classroom' value={`https://upskillinstitute-au.firebaseapp.com/trafficImplementation?trainerId=${userData.trainerId}&delivery=classroom`} />

      <input style={{ display: 'none' }} readOnly id='dec-online' value={`https://upskillinstitute-au.firebaseapp.com/declaration?trainerId=${userData.trainerId}&delivery=online`} />
      <input style={{ display: 'none' }} readOnly id='dec-classroom' value={`https://upskillinstitute-au.firebaseapp.com/declaration?trainerId=${userData.trainerId}&delivery=classroom`} />

      {/* <input style={{ display: 'none' }} readOnly id='dec-traffic-online' value={`https://upskillinstitute-au.firebaseapp.com/dec-trafficControl?trainerId=${userData.trainerId}&delivery=online`} /> */}
      <input style={{ display: 'none' }} readOnly id='dec-traffic-classroom' value={`https://upskillinstitute-au.firebaseapp.com/dec-trafficControl?trainerId=${userData.trainerId}&delivery=classroom`} />
      {/* <input style={{ display: 'none' }} readOnly id='dec-traffic-implement-online' value={`https://upskillinstitute-au.firebaseapp.com/dec-trafficImplementation?trainerId=${userData.trainerId}&delivery=online`} /> */}
      <input style={{ display: 'none' }} readOnly id='dec-traffic-implement-classroom' value={`https://upskillinstitute-au.firebaseapp.com/dec-trafficImplementation?trainerId=${userData.trainerId}&delivery=classroom`} />

      {/* <input style={{ display: 'none' }} readOnly id='decl' value={`https://whitecards-8ffd2.web.app/declaration?trainerId=${userData.trainerId}`} />
      <input style={{ display: 'none' }} readOnly id='qld-eoi' value={`https://whitecards-8ffd2.web.app/qldEoi?trainerId=${userData.trainerId}`} />
      <input style={{ display: 'none' }} readOnly id='review' value={`https://g.page/r/CePVWCrQ8vMEEB0/review`} /> */}
    </div>}


    <ModalComponent
      showModal={!!showGenerateReport}
      setShowModal={setShowGenerateReport}
      contentClassName="qiReportModal"
      contentStyle={{ width: '90vw', maxWidth: '590px', padding: 0, border: 'none', borderRadius: '18px', overflow: 'hidden' }}
    >
      <div className="qiReportHeader">
        <span>{qiReportCourse === 'Traffic Control' ? 'Traffic Controller' : 'Traffic Implementer'}</span>
        <h2>Download QI Report</h2>
        <p>Choose the reporting period to include in the exported CSV file.</p>
      </div>
      <div className="qiReportBody">
        <label className="qiReportCourseField"><span>Course</span><select value={qiReportCourse} onChange={(event) => setQiReportCourse(event.target.value)}><option value="Traffic Control">Traffic Controller</option><option value="Traffic Implement">Traffic Implementer</option></select></label>
        <div className="qiReportDateGrid">
          <label className="classFilterField">
            <span>Start Date</span>
            <MyCalendar longDate startDate={startDate} setStartDate={setStartDate} />
          </label>
          <span className="qiReportDateArrow" aria-hidden="true">→</span>
          <label className="classFilterField">
            <span>End Date</span>
            <MyCalendar longDate startDate={endDate} setStartDate={setEndDate} />
          </label>
        </div>
        <div className="qiReportNote">
          <svg aria-hidden="true" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/></svg>
          The report includes declarations submitted within the selected dates.
        </div>
      </div>
      <div className="qiReportActions">
        <button type="button" className="qiReportCancel" onClick={() => setShowGenerateReport(false)}>Cancel</button>
        <button type="button" className="qiReportSubmit" disabled={loading} onClick={handleGenerateReport}>
          <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v12M7 10l5 5 5-5"/><path d="M5 21h14"/></svg>
          {loading ? 'Preparing...' : 'Download Report'}
        </button>
      </div>
    </ModalComponent>

    <ModalComponent
      showModal={!!showReportsPopup}
      setShowModal={setShowReportsPopup}
      contentClassName="reportsModal"
      contentStyle={{ width: '92vw', maxWidth: '680px', padding: 0, border: 'none', borderRadius: '18px', overflow: 'visible' }}
    >
      <div className="reportsModalHeader">
        <span>Administration</span>
        <h2>Generate Report</h2>
        <p>Choose a date range and filters for the report export.</p>
      </div>

      <div className="reportsModalBody">
        <section className="reportsModalSection">
          <div className="reportsModalSectionTitle">
            <svg aria-hidden="true" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 10h18"/></svg>
            Reporting Period
          </div>
          <div className="reportsDateGrid">
            <label><span>Start Date</span><MyCalendar longDate startDate={reportStartDate} setStartDate={setReportStartDate} /></label>
            <span className="reportsDateArrow" aria-hidden="true">→</span>
            <label><span>End Date</span><MyCalendar longDate startDate={reportEndDate} setStartDate={setReportEndDate} /></label>
          </div>
        </section>

        <section className="reportsModalSection">
          <div className="reportsModalSectionTitle">
            <svg aria-hidden="true" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5 12 16l8 3.5"/><path d="M4 4.5h16v11H4z"/><path d="M8 8h8M8 12h5"/></svg>
            Report Details
          </div>
          <div className="reportsFilterGrid">
            <div className="reportsFilterField"><Dropdown options={reportCourseOptions} value={reportCourse} setValue={setReportCourse} label={'Course'} placeholder="Select course" errorFields={[]} name={''} /></div>
            <div className="reportsFilterField"><Dropdown options={reportTrainerOptions} value={reportTrainer} setValue={setReportTrainer} label={'Trainer'} placeholder="All trainers" errorFields={[]} name={''} /></div>
            <div className="reportsFilterField reportsFilterFull"><Dropdown options={reportTypeOptions} value={reportType} setValue={setReportType} label={'Report Type'} placeholder="Select report type" errorFields={[]} name={''} /></div>
          </div>
        </section>
      </div>

      <div className="reportsModalActions">
        <button type="button" className="reportsModalCancel" onClick={() => setShowReportsPopup(false)}>Cancel</button>
        <button type="button" className="reportsModalSubmit" disabled={loading || !reportCourse?.value || !reportType?.value} onClick={handleGenerateAuditReport}>
          <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v12M7 10l5 5 5-5"/><path d="M5 21h14"/></svg>
          {loading ? 'Generating...' : 'Generate Report'}
        </button>
      </div>
    </ModalComponent>



    <ModalComponent
      showModal={showCreateCourses}
      setShowModal={setShowCreateCourses}
      contentClassName="createCourseModal"
      contentStyle={{ width: '94%', maxWidth: '900px', maxHeight: '90vh', padding: 0, border: 'none', borderRadius: '20px', overflow: 'auto' }}
    >
      <div className="createCourseModalHeader">
        <h2>Schedule Classes</h2>
        <p>Set the course details and add one or more training dates.</p>
      </div>

      <div className="createCourseModalBody">
        <div className="createCourseCredentials">
          <label className="classFilterField">
            <span>Username</span>
            <input placeholder="User name" value={username} onChange={(e) => setUserName(e.target.value)} />
          </label>
          <label className="classFilterField">
            <span>Password</span>
            <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </label>
        </div>

        <div className="createCourseSelects">
          <div className="createCourseSelectField">
            <Dropdown options={createCourseOptions.map(r => r.name)} value={courseType} setValue={setCourseType} label={'Course Type'} errorFields={[]} name={''} />
          </div>
          <div className="createCourseSelectField">
            <Dropdown options={courseTrainers} value={courseTrainer} setValue={setCourseTrainer} label={'Course Trainer'} errorFields={[]} name={''} />
          </div>
        </div>

        <div className="createCourseDates">
          <div className="createCourseDatesHeader">
            <div>
              <strong>Training dates</strong>
              <span>Add every date included in this course.</span>
            </div>
            <button type="button" className="createCourseAddDate" aria-label="Add date" title="Add date" onClick={() => setCourseStartDates([...courseStartDates, new Date()])}>
              <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 10h18"/></svg>
              <span aria-hidden="true">+</span> Date
            </button>
          </div>
          <div className="createCourseDateList">
            {courseStartDates.map((date, index) => (
              <div className="createCourseDateRow" key={`${date?.toString()}-${index}`}>
                <span className="createCourseDateNumber">{index + 1}</span>
                <MyCalendar longDate startDate={date} setStartDate={a => setCourseStartDates(courseStartDates.map((r, idx) => idx === index ? a : r))} />
                <button type="button" className="createCourseRemoveDate" aria-label={`Remove date ${index + 1}`} onClick={() => setCourseStartDates(courseStartDates.filter((r, idx) => index !== idx))}>
                  <svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v5M14 11v5"/></svg>
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="createCourseModalActions">
        <button type="button" className="createCourseCancel" onClick={() => setShowCreateCourses(false)}>Cancel</button>
        <button type="button" className="createCourseSubmit" disabled={!courseTrainer || !courseType || !username || !password || courseStartDates.length === 0 || loading} onClick={handleCreateCourse}>{loading ? 'Creating...' : 'Create Course'}</button>
      </div>
    </ModalComponent>

    <ModalComponent
      showModal={showDownloadEoiPopup}
      setShowModal={setShowDownloadEoiPopup}
      contentClassName="downloadEoiModal"
      contentStyle={{ width: '90vw', maxWidth: '560px', padding: 0, border: 'none', borderRadius: '18px', overflow: 'hidden' }}
    >
      <div className="downloadEoiHeader">
        <span>Course Documents</span>
        <h2>Download EOI</h2>
        <p>Select one or more students from this course.</p>
      </div>
      <div className="downloadEoiBody">
        <div className="downloadEoiListHeader">
          <strong>Students</strong>
          <button type="button" onClick={() => setDownloadEoiIds(downloadEoiIds.length === downloadableEoiRows.length ? [] : downloadableEoiRows.map((row) => row.eoi.id))}>
            {downloadEoiIds.length === downloadableEoiRows.length && downloadableEoiRows.length > 0 ? 'Clear All' : 'Select All'}
          </button>
        </div>
        <div className="downloadEoiStudentList">
          {downloadableEoiRows.length > 0 ? downloadableEoiRows.map((row) => {
            const checked = downloadEoiIds.includes(row.eoi.id)
            return (
              <label className={checked ? 'selected' : ''} key={row.eoi.id}>
                <input type="checkbox" checked={checked} onChange={() => toggleDownloadEoi(row.eoi.id)} />
                <span className="downloadEoiCheck" aria-hidden="true">✓</span>
                <span className="downloadEoiStudentName">{row.fullName || 'Unnamed student'}<small>{row.dob ? `Date of birth: ${row.dob}` : 'EOI available'}</small></span>
              </label>
            )
          }) : <p className="downloadEoiEmpty">No downloadable EOIs are available for this course.</p>}
        </div>
      </div>
      <div className="downloadEoiActions">
        <span>{downloadEoiIds.length} selected</span>
        <button type="button" className="downloadEoiCancel" onClick={() => setShowDownloadEoiPopup(false)}>Cancel</button>
        <button type="button" className="downloadEoiSubmit" disabled={downloadEoiIds.length === 0} onClick={handleDownloadSelectedEois}>Download</button>
      </div>
    </ModalComponent>




    <ModalComponent
      showModal={!!showLodgePopup}
      setShowModal={setShowLodgePopup}
      contentStyle={{ width: '95vw', maxWidth: '1280px' }}
    >
      <> <h2 style={{ textAlign: 'center' }}>Lodge Students</h2>
        <div style={lodgeFieldRowStyle}>
          <label style={lodgeFieldLabelStyle}>Course No:</label>
          <input style={lodgeFieldInputStyle} placeholder="GIxxxxxx" value={courseNo} onChange={(e) => setCourseNo(e.target.value)} ></input>
        </div>
        <div style={lodgeFieldRowStyle}>
          <label style={lodgeFieldLabelStyle}>Username:</label>
          <input style={lodgeFieldInputStyle} placeholder="user-name" value={username} onChange={(e) => setUserName(e.target.value)} ></input>
        </div>
        <div style={lodgeFieldRowStyle}>
          <label style={lodgeFieldLabelStyle}>Password:</label>
          <input style={lodgeFieldInputStyle} placeholder="xxxxx" value={password} onChange={(e) => setPassword(e.target.value)} ></input>
        </div>
        <label style={{ fontWeight: 'bold' }}>Selected Students</label>
        {renderSelectedStudentsTable()}

        <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'center' }}>
          <button disabled={loading || !username || !courseNo || !password || !allLodgeRowsConfirmed} onClick={handleLodgeEoi}>{loading ? 'Loading...' : 'Lodge'}</button>
          <button style={{ marginLeft: '40px', display: 'flex', color: '#FF7100', background: 'white', border: '1px solid #FF7100' }} onClick={() => setShowLodgePopup(false)}>Close</button>
        </div>
      </>
    </ModalComponent>

    <ModalComponent
      showModal={!!markTask}
      setShowModal={() => { setMarkTask(null); setMarkDraft({}) }}
      contentClassName="trafficMarkModal"
      contentStyle={{ width: '94vw', maxWidth: '720px', padding: 0, border: 'none', borderRadius: '20px', overflow: 'hidden' }}
    >
      {markTask && (() => {
        const markRows = getTrafficMarkRows(markTask)
        const eligibleRows = markRows.filter((markRow) => markRow.eligible)
        const selectedCount = eligibleRows.filter((markRow) => markDraft[markRow.row.id]).length
        return (
          <>
            <div className="trafficMarkHeader">
              <span className="trafficMarkEyebrow">Bulk marking</span>
              <h2>{markTask.name || markTask.type}</h2>
              <p>Set an outcome for each student, then save. Marking C marks every requirement in this section as C and completes it.</p>
            </div>
            <div className="trafficMarkBody">
              <div className="trafficMarkToolbar">
                <span>{selectedCount} of {eligibleRows.length} ready to save</span>
                <div className="trafficMarkToolbarActions">
                  <button
                    type="button"
                    onClick={() => setMarkDraft(eligibleRows.reduce((acc, markRow) => ({ ...acc, [markRow.row.id]: 'C' }), {}))}
                    disabled={eligibleRows.length === 0 || savingTrafficMarks}
                  >
                    Mark All as C
                  </button>
                  <button type="button" onClick={() => setMarkDraft({})} disabled={selectedCount === 0 || savingTrafficMarks}>Clear</button>
                </div>
              </div>
              {markRows.length === 0 && <p className="trafficMarkEmpty">No students have this section yet.</p>}
              <div className="trafficMarkList">
                {markRows.map((markRow) => (
                  <div key={markRow.row.id} className={`trafficMarkRow ${markRow.eligible ? '' : 'trafficMarkRowDisabled'}`}>
                    <div>
                      <strong>{markRow.row.fullName || 'Unnamed student'}</strong>
                      {!markRow.eligible && <small>{getTrafficStageStatusLabel(markRow.state || {})}</small>}
                    </div>
                    {markRow.eligible ? (
                      <div className="trafficMarkButtons">
                        {['C', 'NYC'].map((mark) => (
                          <button
                            key={mark}
                            type="button"
                            className={markDraft[markRow.row.id] === mark ? `selected ${mark === 'C' ? 'pass' : 'fail'}` : ''}
                            onClick={() => setMarkDraft((current) => (
                              current[markRow.row.id] === mark
                                ? Object.fromEntries(Object.entries(current).filter(([key]) => key !== markRow.row.id))
                                : { ...current, [markRow.row.id]: mark }
                            ))}
                            disabled={savingTrafficMarks}
                          >
                            {mark}
                          </button>
                        ))}
                      </div>
                    ) : <span className="trafficMarkRowNote">Not awaiting marking</span>}
                  </div>
                ))}
              </div>
            </div>
            <div className="trafficMarkActions">
              <button type="button" className="trafficMarkCancel" onClick={() => { setMarkTask(null); setMarkDraft({}) }}>Cancel</button>
              <button type="button" className="trafficMarkSubmit" onClick={handleSaveTrafficMarks} disabled={selectedCount === 0 || savingTrafficMarks}>
                {savingTrafficMarks ? 'Saving...' : `Save Marks${selectedCount > 0 ? ` (${selectedCount})` : ''}`}
              </button>
            </div>
          </>
        )
      })()}
    </ModalComponent>

    <ModalComponent
      showModal={!!showLodgeTrafficPopup}
      setShowModal={setShowLodgeTrafficPopup}
      contentClassName="lodgeTrafficModal"
      contentStyle={{ width: '94vw', maxWidth: '1180px', padding: 0, border: 'none', borderRadius: '20px', overflow: 'hidden' }}
    >
      <div className="lodgeTrafficHeader">
        <span className="lodgeTrafficEyebrow">Traffic Courses</span>
        <h2>Lodge Students</h2>
        <p>Enter the RTO details, then review and confirm each selected student.</p>
      </div>

      <div className="lodgeTrafficBody">
        <div className="lodgeTrafficFields">
          <label>
            <span>{currentTab === 'Traffic Control' ? 'Traffic Control' : 'Traffic Implement'} Course No.</span>
            <input placeholder="GIxxxxxx" value={courseNo} onChange={(e) => setCourseNo(e.target.value)} />
          </label>
          <label>
            <span>{currentTab === 'Traffic Control' ? 'Traffic Implement' : 'Traffic Control'} Course No.</span>
            <input placeholder="GIxxxxxx" value={courseNoAlternate} onChange={(e) => setCourseNoAlternate(e.target.value)} />
          </label>
          <label>
            <span>Username</span>
            <input placeholder="User name" value={username} onChange={(e) => setUserName(e.target.value)} />
          </label>
          <label>
            <span>Password</span>
            <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </label>
        </div>

        <section className="lodgeTrafficStudents">
          <div className="lodgeTrafficStudentsHeader">
            <div>
              <h3>Selected Students <span>{selectedRows.length}</span></h3>
              <p>Check the details below and tick each student to confirm.</p>
            </div>
            <span className={`lodgeTrafficConfirmationStatus ${allLodgeRowsConfirmed ? 'complete' : ''}`}>
              {Object.values(lodgeConfirmations).filter(Boolean).length} of {selectedRows.length} confirmed
            </span>
          </div>
          {renderSelectedStudentsTable()}
        </section>
      </div>

      <div className="lodgeTrafficActions">
        <button type="button" className="lodgeTrafficCancel" onClick={() => setShowLodgeTrafficPopup(false)}>Cancel</button>
        <button type="button" className="lodgeTrafficSubmit" disabled={loading || !username || !courseNo || !password || !allLodgeRowsConfirmed} onClick={handleLodgeTrafficEoi}>{loading ? 'Lodging...' : 'Lodge Students'}</button>
      </div>
    </ModalComponent>


    <div className="dashboardWorkspace">
      <aside className="tabBar">
      <p className="dashboardSidebarLabel">Workspace</p>
      <nav className="dashboardSectionNav" aria-label="Main navigation">
        {visiblePrimaryTabs.map(tab => {
          const label = tab
          const isDashboardTab = tab === 'Dashboard'
          const isTrainersTab = tab === 'Trainers'
          const isAdminTab = tab === 'Admin'
          const isCourseBuilderTab = tab === 'Course Builder'
          const isCoursesTab = tab === 'Courses'
          const isClassesTab = tab === 'Classes' || tab === 'My Classes'
          const isStudentsTab = tab === 'Students'
          const isMyProfileTab = tab === 'My Profile'
          const isComplianceTab = tab === 'Compliance'
          const isReportsTab = tab === 'Reports'
          const isStatsTab = tab === 'Stats'
          const isActive = tab === 'Courses'
            ? courseWorkspace === 'courses' && currentTab === 'Course Builder'
            : isClassesTab
              ? courseWorkspace === 'classes' && DASHBOARD_TABS.includes(currentTab)
              : currentTab === tab
          return (
            <button className={`dashboardSectionNavItem ${isActive ? 'active' : ''}`} type="button" key={tab} aria-current={isActive ? 'page' : undefined} onClick={() => {
              requestedClassIdRef.current = ''
              if (isClassesTab) {
                setCourseWorkspace('classes')
                if (!isAdminUser) {
                  setClassCourseFilter('')
                  setClassDateFilter('')
                } else {
                  setClassCourseFilter('__all__')
                  setFilter(undefined)
                  setClassDateFilter('')
                }
                setSelectedClassId('')
                setShowClassResults(true)
                setCurrentTab(DASHBOARD_TABS.includes(currentTab) ? currentTab : 'White Card')
              } else if (tab === 'Students') {
                setCourseWorkspace('classes')
                setCurrentTab('Students')
              } else {
                if (tab === 'Courses') {
                  setCourseWorkspace('courses')
                  setCurrentTab('Course Builder')
                } else {
                  setCurrentTab(tab)
                }
              }
              setSelectedRows([])
            }}>
              <span className="dashboardSectionNavIcon" aria-hidden="true">
                {isDashboardTab ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>
                ) : isTrainersTab ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>
                ) : isAdminTab ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .34 1.88l.06.06-2.1 2.1-.06-.06a1.7 1.7 0 0 0-1.88-.34 1.7 1.7 0 0 0-1.04 1.56v.08h-3v-.08a1.7 1.7 0 0 0-1.04-1.56 1.7 1.7 0 0 0-1.88.34l-.06.06-2.1-2.1.06-.06A1.7 1.7 0 0 0 7.04 15 1.7 1.7 0 0 0 5.48 14H5.4v-3h.08A1.7 1.7 0 0 0 7.04 9.96 1.7 1.7 0 0 0 6.7 8.08l-.06-.06 2.1-2.1.06.06a1.7 1.7 0 0 0 1.88.34 1.7 1.7 0 0 0 1.04-1.56v-.08h3v.08a1.7 1.7 0 0 0 1.04 1.56 1.7 1.7 0 0 0 1.88-.34l.06-.06 2.1 2.1-.06.06a1.7 1.7 0 0 0-.34 1.88A1.7 1.7 0 0 0 20.52 11h.08v3h-.08A1.7 1.7 0 0 0 19.4 15z"/></svg>
                ) : isCourseBuilderTab ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v16H6.5A2.5 2.5 0 0 0 4 21.5z"/><path d="M4 5.5v16M9 8h6M12 5v6"/></svg>
                ) : isComplianceTab ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"/><path d="m9 12 2 2 4-4"/></svg>
                ) : isReportsTab ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 3h9l3 3v15H6z"/><path d="M15 3v4h4M9 12h6M9 16h6"/></svg>
                ) : isStatsTab ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 20V10M10 20V4M16 20v-7M22 20H2"/></svg>
                ) : isStudentsTab ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="8" r="3"/><path d="M3 20v-1a6 6 0 0 1 12 0v1"/><path d="M16 5a3 3 0 0 1 0 6M18 14a5 5 0 0 1 3 5"/></svg>
                ) : isMyProfileTab ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/><path d="M19 3v5M16.5 5.5h5"/></svg>
                ) : isCoursesTab ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v16H6.5A2.5 2.5 0 0 0 4 21.5z"/><path d="M4 5.5v16M8 7h8M8 11h6"/></svg>
                ) : isClassesTab ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5 12 16l8 3.5"/><path d="M4 4.5h16v11H4z"/><path d="M8 8h8M8 12h5"/></svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5 12 16l8 3.5"/><path d="M4 4.5h16v11H4z"/><path d="M8 8h8M8 12h5"/></svg>
                )}
              </span>
              <span>{label}</span>
            </button>
          )
        })}
      </nav>
      <button className="dashboardSidebarSignOut" type="button" onClick={() => auth.signOut()}>
        <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 17l5-5-5-5"/><path d="M15 12H3"/><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/></svg>
        <span>Sign Out</span>
      </button>
      <div className="dashboardSidebarUser">
        <span className="dashboardSidebarAvatar" aria-hidden="true">{String(userData?.name || userData?.trainerId || 'U').trim().charAt(0).toUpperCase()}</span>
        <span>
          <small>Logged in</small>
          <strong>{userData?.name || [userData?.firstName, userData?.lastName].filter(Boolean).join(' ') || userData?.trainerId || 'Upskill user'}</strong>
          <small>{userData?.role === 'admin' ? 'Administrator' : 'Trainer'}</small>
        </span>
      </div>
      </aside>
      <main className="dashboardMain">
      {courseWorkspace === 'classes' && DASHBOARD_TABS.includes(currentTab) && (
        <div className="courseToolbar">
        <div className={`classFilterBar ${isAdminUser ? '' : 'trainerClassFilterBar'}`} aria-label="Filter classes">
          <label className="classFilterField">
            <span>Course:</span>
            <select value={isAdminUser ? (classCourseFilter || currentTab) : classCourseFilter} onChange={(event) => {
              const courseTab = event.target.value
              setClassCourseFilter(courseTab)
              if (courseTab && courseTab !== '__all__') setCurrentTab(courseTab)
              setSelectedClassId('')
              setShowClassResults(true)
              setSelectedRows([])
            }}>
              {isAdminUser ? <option value="__all__">All Courses</option> : <option value="">Select course</option>}
              {DASHBOARD_TABS.map((courseTab) => <option key={courseTab} value={courseTab}>{courseTab === 'White Card' ? 'White Card NSW' : courseTab === qldTab ? 'White Card QLD' : courseTab === 'Traffic Control' ? 'Traffic Controller' : 'Traffic Implementer'}</option>)}
            </select>
          </label>
          {isAdminUser && <label className="classFilterField">
            <span>Trainer:</span>
            <select value={filter?.value || ''} onChange={(event) => {
              const trainer = trainers.find((item) => item.trainerId === event.target.value)
              setFilter(trainer ? { value: trainer.trainerId, label: trainer.name } : undefined)
              setSelectedClassId('')
              setShowClassResults(true)
            }}>
              <option value="">All Trainers</option>
              {trainers.map((trainer) => <option key={trainer.trainerId} value={trainer.trainerId}>{trainer.name}</option>)}
            </select>
          </label>}
          <label className="classFilterField">
            <span>Date:</span>
            <input type="date" value={classDateFilter} onChange={(event) => { setClassDateFilter(event.target.value); setSelectedClassId(''); setShowClassResults(true) }} />
          </label>
          <div className="classFilterLinks">
            <div className="dropdown">
              <label className="hover copyLinkPill">
                <svg aria-hidden="true" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                EOI Link
              </label>
              <div className="dropdown-content">
                <label className="hover" style={{ color: 'white' }} onClick={() => copyTextToClipboard('eoi-online', 'White Card Online')}>White Card EOI Online Link</label>
                <label className="hover" style={{ color: 'white' }} onClick={() => copyTextToClipboard('eoi-classroom', 'White Card Classroom')}>White Card EOI Class Link</label>
                <label className="hover" style={{ color: 'white' }} onClick={() => copyTextToClipboard('eoi-traffic-classroom', 'Traffic Control Classroom')}>Traffic Control EOI Class Link</label>
                <label className="hover" style={{ color: 'white' }} onClick={() => copyTextToClipboard('eoi-traffic-implement-classroom', 'Traffic Implement Classroom')}>Traffic Implement EOI Class Link</label>
              </div>
            </div>
            <div className="dropdown">
              <label className="hover copyLinkPill">
                <svg aria-hidden="true" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                Declaration Link
              </label>
              <div className="dropdown-content">
                <label className="hover" style={{ color: 'white' }} onClick={() => copyTextToClipboard('dec-online', 'White Card Online')}>White Card Dec Online Link</label>
                <label className="hover" style={{ color: 'white' }} onClick={() => copyTextToClipboard('dec-classroom', 'White Card Classroom')}>White Card Dec Class Link</label>
                <label className="hover" style={{ color: 'white' }} onClick={() => copyTextToClipboard('dec-traffic-classroom', 'Traffic Control Classroom')}>Traffic Control Dec Class Link</label>
                <label className="hover" style={{ color: 'white' }} onClick={() => copyTextToClipboard('dec-traffic-implement-classroom', 'Traffic Implement Classroom')}>Traffic Implement Dec Class Link</label>
              </div>
            </div>
          </div>
        </div>
        {!enableMultiSelect && userData?.role === 'admin' && currentTab !== qldTab && <button className="createClassAction" type="button" onClick={() => setShowCreateCourses(true)}>
          <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M16 3v4" /><path d="M8 3v4" /><path d="M3 10h18" /><path d="M12 13v5" /><path d="M9.5 15.5h5" /></svg>
          Schedule Classes
        </button>}
      {!placeholderTabs.includes(currentTab) && <div className="tabBarActions">
        <div className="tabBarLinkRow">
        {currentTab === qldTab && (
          <>
            <button className="topReportAction" type="button" onClick={() => setQldStudentNumbersSignal(Date.now())}>
              <svg aria-hidden="true" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 7h16M4 12h16M4 17h10"/><path d="M18 15v6M15 18h6"/></svg>
              Generate Student Numbers
            </button>
            <button
              className="topReportAction"
              type="button"
              disabled={!qldToolbarState.canGenerateGcit || qldToolbarState.isGeneratingGcit}
              title={!qldToolbarState.canGenerateGcit ? 'Complete all sections before generating the GCIT report template.' : ''}
              onClick={() => setQldGcitSignal(Date.now())}
            >
              <svg aria-hidden="true" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 2h9l5 5v15H6z"/><path d="M14 2v6h6M9 13h8M9 17h6"/></svg>
              {qldToolbarState.isGeneratingGcit ? 'Generating GCIT...' : 'Generate GCIT'}
            </button>
          </>
        )}
        </div>
      </div>}
        </div>
      )}
    <div className="dashboardContextActions" style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'flex-end', gap: '8px', flexWrap: 'wrap' }}>

      {!enableMultiSelect && selectedRecord && selectedSubmissionType === 'eoi' && (
        <>
          {currentTab === 'White Card' && <button className="textButton" onClick={() => { setSelectedRows([selectedRecord]); setShowLodgePopup(true) }}>Lodge</button>}
        </>
      )}
      {!enableMultiSelect && selectedRecord && selectedSubmissionType === 'declaration' && (
        <a className="textButton" href={`${downloadFileUrl}?url=${selectedRecord.pdf}`}>Download Declaration</a>
      )}
      {!enableMultiSelect && selectedRecord && (
        <>
          {!selectedRecord.completed && (
            <button
              className="textButton"
              disabled={selectedSubmissionType === 'eoi' && !isTrainerVerificationComplete(selectedRecord.data)}
              onClick={() => toggleVerified(selectedRecord)}
            >
              {!selectedRecord.verified ? 'Satisfactory' : 'Cannot proceed'}
            </button>
          )}
          {selectedRecord.verified && (
            <button className="textButton" onClick={() => toggleCompleted(selectedRecord)}>
              {!selectedRecord.completed ? 'Mark Completed' : 'Undo Completed'}
            </button>
          )}
        </>
      )}


    </div>

    <div className="wrapper" style={{ justifyContent: 'flex-start', gap: '20px', alignItems: 'flex-start', marginTop: '8px' }}>
      {currentTab === 'Dashboard' ? (
        <div className={`dashboardCalendarLayout ${isAdminUser ? '' : 'trainerDashboardCalendarLayout'}`}>
        <section className="dashboardCalendar" aria-labelledby="dashboard-calendar-heading">
          <div className="dashboardCalendarHeader">
            <div>
              <h2 id="dashboard-calendar-heading">Course Calendar</h2>
              <p>All scheduled courses and their assigned trainers.</p>
            </div>
            <div className="dashboardCalendarControls">
              <button type="button" onClick={() => changeDashboardMonth((month) => subMonths(month, 1))} aria-label="Previous month">‹</button>
              <button type="button" onClick={() => changeDashboardMonth(() => startOfMonth(new Date()))}>Today</button>
              <button type="button" onClick={() => changeDashboardMonth((month) => addMonths(month, 1))} aria-label="Next month">›</button>
            </div>
           </div>
           <p className="dashboardCalendarRange">{format(dashboardMonth, 'MMMM yyyy')}</p>
          <div className="dashboardCalendarWeekdays" aria-hidden="true">
            {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day) => <span key={day}>{day}</span>)}
          </div>
           <div className="dashboardCalendarGrid">
            {dashboardCalendarDays.map((date) => {
              const dateKey = format(date, 'yyyy-MM-dd')
              const classes = dashboardClassesByDate[dateKey] || []
              const isToday = dateKey === format(new Date(), 'yyyy-MM-dd')
              const isOutsideCurrentMonth = date.getMonth() !== dashboardMonth.getMonth()
              return <section className={`dashboardCalendarDay ${isToday ? 'today' : ''} ${isOutsideCurrentMonth ? 'outsideMonth' : ''}`} key={dateKey}>
                <header>
                  <span>{format(date, 'EEE')}</span>
                  <strong>{format(date, 'd')}</strong>
                </header>
                <div className="dashboardCalendarEntries">
                  {classes.length ? classes.map((courseClass) => {
                    const trainerName = courseClass.trainerName || trainers.find((trainer) => trainer.trainerId === courseClass.trainerId)?.name || courseClass.trainerId || 'Unassigned trainer'
                    return <div className={`calendarClassCard ${courseClass.status === 'cancelled' ? 'calendarClassCancelled' : ''}`} key={courseClass.id || courseClass.classId}><button type="button" className={`dashboardCalendarEntry ${courseClass.courseTypeKey || ''}`} onClick={() => openDashboardCourse(courseClass)} title={`Open ${DASHBOARD_COURSE_LABELS[courseClass.courseTypeKey] || courseClass.courseName || 'course'}`}>
                      <strong>{DASHBOARD_COURSE_LABELS[courseClass.courseTypeKey] || courseClass.courseName || courseClass.courseLabel || 'Course'}</strong>
                      <span>{trainerName}</span>
                      {courseClass.status === 'cancelled' && <strong>Cancelled</strong>}
                      {(courseClass.startTime || courseClass.delivery) && <small>{[courseClass.startTime, courseClass.delivery].filter(Boolean).join(' · ')}</small>}
                    </button>{isAdminUser && <button type="button" className="calendarEditClass" aria-label={`Edit class ${trainerName} ${dateKey}`} onClick={() => setEditingClass(courseClass)}>Edit class</button>}</div>
                  }) : <p className="dashboardCalendarEmpty">No courses</p>}
                </div>
              </section>
            })}
          </div>
        </section>
        {editingClass && <EditClassModal key={editingClass.id || editingClass.classId} courseClass={editingClass} onClose={() => setEditingClass(null)} onSaved={({ courseClass, updatedRecords }) => {
          setAdminClasses(current => [...current.filter(row => row.id !== courseClass.id), courseClass])
          courseDataLoadRef.current = { userKey: '', mode: '', loadedAt: 0 }
          monthDataLoadRef.current = { userKey: '', monthKey: '' }
          setClassEditVersion(version => version + 1)
          setEditingClass(null)
          showSuccessMessage(`Class updated. ${updatedRecords} linked records updated.`)
        }} />}
        {isAdminUser && <aside className="dashboardSummaryCards" aria-label="Dashboard summaries">
          <section className="dashboardSummaryCard">
            <div className="dashboardSummaryCardHeader">
              <h2>Outstanding Lodgements</h2>
              <span>{dashboardLodgementClasses.length} {dashboardLodgementClasses.length === 1 ? 'course' : 'courses'}</span>
            </div>
            <div className="dashboardSummaryCardContent">
            {dashboardLodgementClasses.length ? (
              <div className="dashboardLodgementTableWrap">
                <table className="dashboardLodgementTable">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Course Name</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dashboardLodgementClasses.slice(0, 8).map((courseClass) => {
                      const statusLabel = courseClass.readyCount > 0
                        ? `${courseClass.readyCount} ready to lodge`
                        : 'Waiting on pipeline'
                      return <tr key={courseClass.id} onClick={() => openDashboardCourse(courseClass)}>
                        <td>{format(new Date(courseClass.scheduledDate || courseClass.dateKey), 'dd MMM yyyy')}</td>
                        <td>{DASHBOARD_COURSE_LABELS[courseClass.courseTypeKey] || courseClass.courseLabel || courseClass.dashboardCourseTab || 'Course'}</td>
                        <td><span className={`dashboardLodgementStatus ${courseClass.readyCount > 0 ? 'ready' : 'pending'}`}>{statusLabel}</span></td>
                      </tr>
                    })}
                  </tbody>
                </table>
              </div>
            ) : <p className="dashboardSummaryEmpty">No overdue lodgements.</p>}
            </div>
          </section>
          <section className="dashboardSummaryCard">
            <div className="dashboardSummaryCardHeader">
              <h2>Students</h2>
              <span>{dashboardStudentRows.length}</span>
            </div>
            <div className="dashboardSummaryCardContent">
            <label className="dashboardStudentSearch">
              <span>Find student</span>
              <input id="dashboard-student-search" value={dashboardStudentSearch} onChange={(event) => setDashboardStudentSearch(event.target.value)} placeholder="Search student name, email, SOT #, or SOC #" />
            </label>
            <div className="dashboardStudentList">
              {dashboardStudentRows.length ? dashboardStudentRows.slice(0, 9).map((student) => (
                <button type="button" className="dashboardStudentItem" key={student.id} onClick={() => openDashboardCourse(student.group)}>
                  <span>
                    <strong>{student.fullName}</strong>
                    <small>{[student.courseLabel, student.trainerName].filter(Boolean).join(' · ')}</small>
                  </span>
                  <em>{student.scheduledDate || student.scheduledDateKey ? format(new Date(student.scheduledDate || student.scheduledDateKey), 'dd MMM') : 'No date'}</em>
                </button>
              )) : <p className="dashboardSummaryEmpty">{dashboardStudentSearch.trim().length >= MIN_STUDENT_SEARCH_LENGTH
                ? (loadingCourseData ? 'Searching student records...' : 'No students found.')
                : `Type at least ${MIN_STUDENT_SEARCH_LENGTH} characters to find a student.`}</p>}
            </div>
            </div>
          </section>
        </aside>}
        </div>
      ) : currentTab === 'Students' ? (
          <section className="studentsDirectoryPage" aria-labelledby="students-directory-heading">
            <header className="studentsDirectoryHeader">
            <div className="studentsDirectoryHeading">
              <div className="trainersPlaceholderIcon" aria-hidden="true"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="8" r="3"/><path d="M3 20v-1a6 6 0 0 1 12 0v1"/><path d="M16 5a3 3 0 0 1 0 6M18 14a5 5 0 0 1 3 5"/></svg></div>
              <div><h2 id="students-directory-heading">Student Profiles</h2><p>Search for a student, then open their profile.</p></div>
            </div>
          </header>
          <div className="studentsDirectoryContent">
          {selectedStudentProfile && <div className="studentsDirectoryGrid">
            {[selectedStudentProfile].map((student) => {
              const profileFields = [
                ['First name', student.firstName],
                ['Middle name', student.middleName],
                ['Last name', student.lastName],
                ['Address', student.address],
                ['Postal address', student.postalAddress],
                ['Mobile', student.mobile],
                ['Email', student.email],
                ['Date of birth', student.dob],
              ]
              return <article className="studentDirectoryCard" key={student.id}>
                <header className="studentDirectoryCardTitle">
                  <span aria-hidden="true">{student.fullName.charAt(0).toUpperCase()}</span>
                  <div><h3>{student.fullName}</h3><small>{student.email || 'Student profile'}</small></div>
                </header>
                <section className="studentDirectorySection">
                  <h4>Profile</h4>
                  <dl className="studentProfileFields">
                    {profileFields.map(([label, value]) => <div key={label}><dt>{label}</dt><dd>{value || '—'}</dd></div>)}
                  </dl>
                </section>
                <section className="studentDirectorySection studentEnrolmentSection">
                  <h4>Course Enrolment</h4>
                  <dl className="studentEnrolmentFields">
                    <div><dt>Course name</dt><dd>{student.courseLabel}</dd></div>
                    <div><dt>Enrolment date</dt><dd>{student.scheduledDate ? format(new Date(student.scheduledDate), 'dd MMM yyyy') : '—'}</dd></div>
                    <div><dt>Completed assessment</dt><dd>{student.assessmentPdf ? <a href={student.assessmentPdf} target="_blank" rel="noreferrer">View PDF</a> : 'No PDF uploaded'}</dd></div>
                  </dl>
                </section>
              </article>
            })}
            <button className="studentProfileBackButton" type="button" onClick={() => setSelectedStudentProfile(null)}>Back to student results</button>
          </div>}
          {!selectedStudentProfile && <>
            <label className="studentsDirectorySearch">
              <span>Find student</span>
              <input value={studentDirectorySearch} onChange={(event) => setStudentDirectorySearch(event.target.value)} placeholder="Search name, DOB, email, mobile, SOC, SOT, or course" />
            </label>
            {studentDirectorySearch.trim().length >= MIN_STUDENT_SEARCH_LENGTH ? loadingCourseData ? <p className="studentsDirectoryEmpty">Searching student records...</p> : studentDirectoryResults.length ? <>
              <div className="studentsDirectoryTableWrap">
              <table className="studentsDirectoryTable">
                <thead><tr><th>Student</th><th>Course</th><th>Enrolment date</th><th aria-label="Open profile" /></tr></thead>
                <tbody>{pagedStudentDirectoryResults.map((student) => <tr key={student.id}>
                  <td><strong>{student.fullName}</strong><small>{student.email || student.mobile || 'No contact details'}</small></td>
                  <td>{student.courseLabel}</td>
                  <td>{student.scheduledDate ? format(new Date(student.scheduledDate), 'dd MMM yyyy') : '—'}</td>
                  <td><button type="button" onClick={() => setSelectedStudentProfile(student)}>Open profile</button></td>
                </tr>)}</tbody>
              </table>
              </div>
              <nav className="classResultsPagination studentsDirectoryPagination" aria-label="Students pagination">
                <span>Showing {(studentResultsPage - 1) * 20 + 1}–{Math.min(studentResultsPage * 20, studentDirectoryResults.length)} of {studentDirectoryResults.length}</span>
                <div>
                  <button type="button" aria-label="Previous page" disabled={studentResultsPage === 1} onClick={() => setStudentResultsPage((page) => Math.max(1, page - 1))}><svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6"/></svg></button>
                  <strong>Page {studentResultsPage} of {studentResultsPageCount}</strong>
                  <button type="button" aria-label="Next page" disabled={studentResultsPage === studentResultsPageCount} onClick={() => setStudentResultsPage((page) => Math.min(studentResultsPageCount, page + 1))}><svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6"/></svg></button>
                </div>
              </nav>
            </> : <p className="studentsDirectoryEmpty">No students match that search.</p> : <p className="studentsDirectoryEmpty">Type at least {MIN_STUDENT_SEARCH_LENGTH} characters to search student records.</p>}
          </>}
          </div>
        </section>
      ) : currentTab === 'My Profile' ? (
        <section className="trainerMyProfilePage" aria-labelledby="my-profile-heading">
          <header className="trainerMyProfileHeader">
            <h2 id="my-profile-heading">My Profile</h2>
            <p>{userData?.name || [userData?.firstName, userData?.lastName].filter(Boolean).join(' ') || userData?.trainerId || 'Trainer'} · Trainer account</p>
          </header>
          <section className="trainerProfileCard">
            <div className="trainerProfileCardHeader"><h3>Details <span className="trainerRequiredMark">*</span></h3></div>
            <div className="trainerDetailsGrid">
              <label>First Name <span className="trainerRequiredMark">*</span><input readOnly value={myProfileFirstName} /></label>
              <label>Last Name <span className="trainerRequiredMark">*</span><input readOnly value={myProfileLastName} /></label>
              <label>Email <span className="trainerRequiredMark">*</span><input readOnly value={userData?.email || ''} /></label>
              <label>Date of Birth <span className="trainerRequiredMark">*</span><input readOnly type="date" value={userData?.dob || userData?.dateOfBirth || ''} /></label>
              <label>Contact Number <span className="trainerRequiredMark">*</span><input readOnly value={userData?.contactNumber || userData?.phone || ''} /></label>
            </div>
          </section>
          <section className="trainerComplianceGroup">
            <div className="trainerComplianceSectionHeader">
              <h3>Compliance</h3>
              <p>Trainer compliance documents and currency records.</p>
            </div>
            <UploadCard title="Resume" showUploadDate />
            <UploadCard title="VET Currency" includeCompletionDate includeRenewalDate categoryOptions={['Professional Development', 'VET Membership', 'Other']} />
            <UploadCard title="Industry Currency" includeCompletionDate />
            <UploadCard title="Trainer Matrix" />
            <UploadCard title="WWCC" showUploadDate />
            <UploadCard title="Qualifications" includeCompletionDate dateFieldLabel="Date of Completion" />
            <UploadCard title="OTHER" showUploadDate />
          </section>
        </section>
      ) : currentTab === 'Trainers' ? (
        selectedTrainerProfile ? <TrainerProfileModal
          embedded
          trainer={selectedTrainerProfile}
          onClose={() => setSelectedTrainerProfile(null)}
          onComplianceChange={(trainer, status) => {
            const trainerKey = trainer.trainerId || trainer.id || trainer.name
            setTrainerComplianceStatuses((current) => ({ ...current, [trainerKey]: status }))
          }}
        /> : <section className="trainersDirectoryPanel" aria-labelledby="trainers-directory-heading">
          <div className="trainersDirectoryHeader">
            <div className="trainersDirectoryHeading">
              <div className="trainersPlaceholderIcon" aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>
              </div>
              <div>
                <h2 id="trainers-directory-heading">Trainer Profiles</h2>
                <p>View and manage trainer profile records.</p>
              </div>
            </div>
            <div className="trainersDirectoryHeaderActions">
              <button className="addTrainerButton" type="button">
                <svg aria-hidden="true" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><path d="M12 5v14M5 12h14"/></svg>
                Trainer
              </button>
            </div>
          </div>
          <div className="trainersDirectoryContent">
          <div className="trainersDirectoryTableWrap">
            <table className="trainersDirectoryTable">
              <colgroup><col className="trainerFirstNameColumn"/><col className="trainerLastNameColumn"/><col className="trainerComplianceColumn"/><col className="trainerActionColumn"/></colgroup>
              <thead><tr><th>First Name</th><th>Last Name</th><th className="trainersComplianceColumn">Compliance</th><th className="trainersActionColumn">Action</th></tr></thead>
              <tbody>
                {[...trainers].sort((a, b) => String(a.name || '').localeCompare(String(b.name || ''))).map((trainer) => {
                  const nameParts = String(trainer.name || '').trim().split(/\s+/).filter(Boolean)
                  const lastName = nameParts.length > 1 ? nameParts.pop() : ''
                  const firstName = nameParts.join(' ')
                  const trainerKey = trainer.trainerId || trainer.id || trainer.name
                  const complianceStatus = trainerComplianceStatuses[trainerKey] || 'pending'
                  return (
                    <tr key={trainerKey}>
                      <td>{firstName}</td>
                      <td>{lastName}</td>
                      <td className="trainersComplianceColumn">
                        <span className={`trainerComplianceStatus ${complianceStatus}`} title={complianceStatus === 'compliant' ? 'Compliant' : complianceStatus === 'nonCompliant' ? 'Non-compliant' : 'Pending review'} aria-label={complianceStatus === 'compliant' ? 'Compliant' : complianceStatus === 'nonCompliant' ? 'Non-compliant' : 'Pending review'}>
                          <svg aria-hidden="true" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round">
                            {complianceStatus === 'compliant' ? <path d="m5 12 4 4L19 6"/> : complianceStatus === 'nonCompliant' ? <><path d="M18 6 6 18"/><path d="m6 6 12 12"/></> : <><path d="M9.6 9a2.7 2.7 0 1 1 4.3 2.2c-1.2.8-1.9 1.3-1.9 2.8"/><path d="M12 17h.01"/></>}
                          </svg>
                        </span>
                      </td>
                      <td className="trainersActionColumn">
                        <button className="trainerProfileViewButton" type="button" aria-label={`View ${trainer.name} profile`} title="View profile" onClick={() => setSelectedTrainerProfile(trainer)}>
                          <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="2.5"/><path d="M5.5 17a3.5 3.5 0 0 1 7 0M15 9h3M15 13h3"/></svg>
                        </button>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          <aside className="trainerKpiPanel" aria-label="Trainer key performance indicators">
            <div className="trainerKpiCard trainerCountKpi">
              <span className="trainerKpiIcon" aria-hidden="true"><svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="8" r="3"/><path d="M3 20v-1a6 6 0 0 1 12 0v1"/><path d="M16 5a3 3 0 0 1 0 6M18 14a5 5 0 0 1 3 5"/></svg></span>
              <span className="trainerKpiLabel">Trainers</span>
              <strong>{trainers.length}</strong>
            </div>
            <div className="trainerKpiCard trainerNonCompliantKpi">
              <span className="trainerKpiIcon" aria-hidden="true"><svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><path d="M15 9 9 15M9 9l6 6"/></svg></span>
              <span className="trainerKpiLabel">Non-Compliant</span>
              <strong>{trainers.filter((trainer) => {
                const trainerKey = trainer.trainerId || trainer.id || trainer.name
                return trainerComplianceStatuses[trainerKey] === 'nonCompliant'
              }).length}</strong>
            </div>
            <div className="trainerKpiCard trainerPendingKpi">
              <span className="trainerKpiIcon" aria-hidden="true"><svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><path d="M9.6 9a2.7 2.7 0 1 1 4.3 2.2c-1.2.8-1.9 1.3-1.9 2.8"/><path d="M12 17h.01"/></svg></span>
              <span className="trainerKpiLabel">Pending Review</span>
              <strong>{trainers.filter((trainer) => {
                const trainerKey = trainer.trainerId || trainer.id || trainer.name
                return (trainerComplianceStatuses[trainerKey] || 'pending') === 'pending'
              }).length}</strong>
            </div>
            <div className="trainerKpiCard trainerRenewalKpi">
              <span className="trainerKpiIcon" aria-hidden="true"><svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 10h18"/><path d="M12 14v3M12 17h.01"/></svg></span>
              <span className="trainerKpiLabel">Upcoming Renewals</span>
              <strong>0</strong>
            </div>
          </aside>
          </div>
        </section>
      ) : currentTab === 'Course Builder' ? (
        isAdminUser ? <CourseBuilder userData={userData} /> : null
      ) : currentTab === 'Reports' ? (
        <section className="reportsPage" aria-labelledby="reports-heading">
          <header className="reportsPageHeader">
            <div className="statsPageHeading">
              <div className="trainersPlaceholderIcon" aria-hidden="true"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 3h9l3 3v15H6z"/><path d="M15 3v4h4M9 12h6M9 16h6"/></svg></div>
              <div><h2 id="reports-heading">Reports</h2><p>Create course audit reports and quality-indicator exports.</p></div>
            </div>
          </header>
          <div className="reportsPageContent">
            <button className="reportsPageAction" type="button" onClick={() => { setReportStartDate(new Date()); setReportEndDate(new Date()); setShowReportsPopup(true) }}><span aria-hidden="true"><svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19V9M10 19V5M16 19v-7M22 19H2"/></svg></span><div><strong>Reports</strong><small>Generate verification and changes reports.</small></div><svg className="reportsPageArrow" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="m9 18 6-6-6-6"/></svg></button>
            <button className="reportsPageAction" type="button" onClick={() => { setQiReportCourse('Traffic Control'); setShowGenerateReport(true) }}><span aria-hidden="true"><svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v12M7 10l5 5 5-5"/><path d="M5 21h14"/></svg></span><div><strong>Generate QI Report</strong><small>Download a quality-indicator report for traffic courses.</small></div><svg className="reportsPageArrow" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="m9 18 6-6-6-6"/></svg></button>
          </div>
        </section>
      ) : currentTab === 'Stats' ? (
        <section className="statsPage" aria-labelledby="stats-heading">
          <header className="statsPageHeader statsInsightsHeader">
            <div className="statsPageHeading"><div className="trainersPlaceholderIcon" aria-hidden="true"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 20V10M10 20V4M16 20v-7M22 20H2"/></svg></div><div><h2 id="stats-heading">Enrolment Insights</h2><p>Compare student enrolments by course, month and year.</p></div></div>
            <div className="statsMonthPicker"><button type="button" aria-label="Previous month" onClick={() => setStatsMonth((month) => startOfMonth(addMonths(month, -1)))}>‹</button><strong>{format(statsMonth, 'MMMM yyyy')}</strong><button type="button" aria-label="Next month" disabled={format(statsMonth, 'yyyy-MM') === format(new Date(), 'yyyy-MM')} onClick={() => setStatsMonth((month) => startOfMonth(addMonths(month, 1)))}>›</button></div>
          </header>
          <div className="statsPageContent statsInsightsContent">
            <div className="statsInsightSummary"><article><div className="statsKpiTitle"><span>Selected month</span><strong>{statsMetrics.currentCount}</strong></div><small>Student enrolments</small></article><article><div className="statsKpiTitle"><span>{format(addYears(statsMonth, -1), 'MMMM yyyy')}</span><strong>{statsMetrics.lastYearCount}</strong></div><small>Same month last year</small></article><article className={statsMetrics.currentCount >= statsMetrics.lastYearCount ? 'positive' : 'negative'}><div className="statsKpiTitle"><span>Year-on-year change</span><strong>{statsMetrics.currentCount - statsMetrics.lastYearCount >= 0 ? '+' : ''}{statsMetrics.currentCount - statsMetrics.lastYearCount}</strong></div><small>Compared with last year</small></article></div>
            <section className="statsYtdChart" aria-labelledby="stats-ytd-heading"><header><div><h3 id="stats-ytd-heading">YTD enrolment momentum</h3><p>Monthly enrolments from January to {format(statsMonth, 'MMMM yyyy')}.</p></div><div className="statsLineLegend"><span><i className="current" />{format(statsMonth, 'yyyy')}</span><span><i className="lastYear" />{format(addYears(statsMonth, -1), 'yyyy')}</span></div></header><div className="statsTrendGraph statsYtdGraph"><div className="statsYAxis"><span>{statsSeriesMax}</span><span>{Math.ceil(statsSeriesMax / 2)}</span><span>0</span></div><div><svg viewBox="0 0 540 164" preserveAspectRatio="none" role="img" aria-label="Year-to-date student enrolments"><defs><linearGradient id="statsLineGradient" x1="0" x2="1"><stop offset="0%" stopColor="#3985bd"/><stop offset="100%" stopColor="#7c4bb0"/></linearGradient></defs><path d="M26 142H514" className="statsGraphAxis" /><path d="M26 86H514" className="statsGraphGuide" /><path d="M26 30H514" className="statsGraphGuide" /><polyline points={statsLastYearGraphPoints} className="statsGraphLastYearLine" />{statsMetrics.lastYearMonthSeries.map((item, index) => <circle key={item.key} cx={26 + (index * (488 / Math.max(1, statsMetrics.lastYearMonthSeries.length - 1)))} cy={142 - ((item.count / statsSeriesMax) * 112)} r="3.5" className="statsGraphLastYearPoint"><title>{item.label} last year: {item.count} enrolments</title></circle>)}<polyline points={statsGraphPoints} className="statsGraphLine" />{activeStatsSeries.map((item, index) => <circle key={item.key} cx={26 + (index * (488 / Math.max(1, activeStatsSeries.length - 1)))} cy={142 - ((item.count / statsSeriesMax) * 112)} r="5" className="statsGraphPoint"><title>{item.label}: {item.count} enrolments</title></circle>)}</svg><div className="statsGraphLabels" style={{ gridTemplateColumns: `repeat(${activeStatsSeries.length}, minmax(0, 1fr))` }}>{activeStatsSeries.map((item) => <span key={item.key}>{item.label}</span>)}</div></div></div></section>
            <section className="statsComparisonBars" aria-labelledby="stats-comparison-heading"><header><div><h3 id="stats-comparison-heading">Course enrolment comparison</h3><p>{format(statsMonth, 'MMMM yyyy')} against the same month last year.</p></div><div className="statsBarLegend"><span><i className="current" />{format(statsMonth, 'MMM yyyy')}</span><span><i className="lastYear" />{format(addYears(statsMonth, -1), 'MMM yyyy')}</span></div></header><div className="statsGroupedBars">{statsMetrics.courseTable.map((course) => { const courseColourClass = course.label.toLowerCase().includes('controller') ? 'controller' : course.label.toLowerCase().includes('implementer') ? 'implementer' : course.label.toLowerCase().includes('qld') ? 'qld' : 'nsw'; return <div className={`statsGroupedBar ${courseColourClass}`} key={course.label}><div className="statsGroupedBarColumns"><div title={`${course.label}: ${course.current} enrolments`}><i className="current" style={{ height: `${Math.max(4, (course.current / statsCourseMax) * 100)}%` }} /></div><div title={`${course.label}: ${course.lastYear} enrolments last year`}><i className="lastYear" style={{ height: `${Math.max(4, (course.lastYear / statsCourseMax) * 100)}%` }} /></div></div><span>{course.label}</span></div> })}</div></section>
            <section className="statsCourseTableCard" aria-labelledby="stats-course-table-heading"><header><div><h3 id="stats-course-table-heading">Monthly enrolment record</h3><p>Use the month selector above to explore historical enrolments.</p></div></header><div className="statsCourseTableWrap"><table><thead><tr><th>Course</th><th>{format(statsMonth, 'MMM yyyy')}</th><th>{format(addYears(statsMonth, -1), 'MMM yyyy')}</th></tr></thead><tbody>{statsMetrics.courseTable.map((course) => <tr key={course.label}><td><span className={`statsCourseDot ${course.label.toLowerCase().includes('controller') ? 'controller' : course.label.toLowerCase().includes('implementer') ? 'implementer' : course.label.toLowerCase().includes('qld') ? 'qld' : 'nsw'}`} />{course.label}</td><td>{course.current}</td><td>{course.lastYear}</td></tr>)}</tbody></table></div></section>
          </div>
        </section>
      ) : placeholderTabs.includes(currentTab) ? (
        <section className="trainersPlaceholder" aria-labelledby="trainers-heading">
          <div className="trainersPlaceholderBanner">
            <div className="trainersPlaceholderIcon" aria-hidden="true">
              {currentTab === 'Admin' ? (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="8" cy="7" r="4"/><path d="M2 21v-2a6 6 0 0 1 9-5.2"/><circle cx="17" cy="17" r="3"/><path d="M17 12.5v1M17 20.5v1M12.5 17h1M20.5 17h1M13.8 13.8l.7.7M19.5 19.5l.7.7M20.2 13.8l-.7.7M14.5 19.5l-.7.7"/></svg>
              ) : currentTab === 'Course Builder' ? (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v16H6.5A2.5 2.5 0 0 0 4 21.5z"/><path d="M4 5.5v16M9 8h6M12 5v6"/></svg>
              ) : currentTab === 'Compliance' ? (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"/><path d="m9 12 2 2 4-4"/></svg>
              ) : (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5 12 16l8 3.5"/><path d="M4 4.5h16v11H4z"/><path d="M8 8h8M8 12h5"/></svg>
              )}
            </div>
            <div>
              <h2 id="trainers-heading">{currentTab}</h2>
              <p>{currentTab === 'Dashboard' ? 'Choose Courses to manage course enrolments and assessments.' : `${currentTab} content will be added here.`}</p>
            </div>
          </div>
        </section>
      ) : currentTab === qldTab ? (
        userData && <DisplayQldAdmin
          initialSelectedLinkId={initialView.currentTab === qldTab ? initialView.selectedClassId : ''}
          onSelectedLinkChange={setSelectedClassId}
          userData={userData}
          trainerFilter={filter}
          onTrainerFilterChange={setFilter}
          trainerDirectory={trainers}
          createSignal={qldCreateSignal}
          onCreateHandled={() => setQldCreateSignal(0)}
          onCreateStudentLink={() => setQldCreateSignal(Date.now())}
          studentNumbersSignal={qldStudentNumbersSignal}
          gcitSignal={qldGcitSignal}
          onToolbarStateChange={setQldToolbarState}
        />
      ) : (
        focusedPipeline && !selectedClassGroup ? (
          <section className="classResultsPanel" aria-live="polite"><h2>Student Pipeline</h2>
            <p>{!userData || loadingCourseData ? 'Loading the selected class and its students...' : 'This class could not be found with your current filters.'}</p>
            {pipelineLoadError && <p role="alert">{pipelineLoadError}</p>}
            <button onClick={() => performFetch(false)}>Retry</button>
            <button onClick={() => { requestedClassIdRef.current = ''; setSelectedClassId(''); setShowClassResults(true) }}>Back to classes</button>
          </section>
        ) : courseWorkspace === 'classes' && (showClassResults || !selectedClassGroup) ? (
          <section className="classResultsPanel" aria-labelledby="class-results-heading">
            <header className="classResultsHeader">
              <div className="classResultsHeading">
                <div className="trainersPlaceholderIcon" aria-hidden="true"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5 12 16l8 3.5"/><path d="M4 4.5h16v11H4z"/><path d="M8 8h8M8 12h5"/></svg></div>
                <div><h2 id="class-results-heading">Classes</h2><p>Select one to open its student pipeline.</p></div>
              </div>
            </header>
            {!isAdminUser && (!classCourseFilter || !classDateFilter) ? null : visibleClassGroups.length ? (
              <>
              <div className="classResultsTableWrap">
                <table className="classResultsTable">
                  <thead><tr><th>Course</th><th>Date</th><th>Trainer</th><th>Students</th><th>Active</th></tr></thead>
                  <tbody>{pagedClassGroups.map((classGroup) => {
                    const trainerName = classGroup.trainerName || trainers.find((trainer) => trainer.trainerId === classGroup.trainerId)?.name || classGroup.trainerId || 'Unassigned trainer'
                    const courseName = currentTab === 'White Card' ? 'White Card NSW' : currentTab === 'Traffic Control' ? 'Traffic Controller' : currentTab === 'Traffic Implement' ? 'Traffic Implementer' : currentTab
                    return <tr key={classGroup.id} onClick={() => { setSelectedClassId(classGroup.id); setSelectedSubmissionType('eoi'); setSelectedRows([]); setShowClassResults(false); dispatch(setCurrenEoi()); dispatch(setCurrenDeclaration()) }}>
                      <td>{courseName}</td><td>{format(new Date(classGroup.scheduledDate || classGroup.scheduledDateKey), 'EEE, dd MMM yyyy')}</td><td>{trainerName}</td><td>{classGroup.studentCount || 0}</td><td><button type="button">View</button></td>
                    </tr>
                  })}</tbody>
                </table>
              </div>
              <nav className="classResultsPagination" aria-label="Classes pagination">
                <span>Showing {(classResultsPage - 1) * 20 + 1}–{Math.min(classResultsPage * 20, visibleClassGroups.length)} of {visibleClassGroups.length}</span>
                <div>
                  <button type="button" aria-label="Previous page" disabled={classResultsPage === 1} onClick={() => setClassResultsPage((page) => Math.max(1, page - 1))}><svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6"/></svg></button>
                  <strong>Page {classResultsPage} of {classResultsPageCount}</strong>
                  <button type="button" aria-label="Next page" disabled={classResultsPage === classResultsPageCount} onClick={() => setClassResultsPage((page) => Math.min(classResultsPageCount, page + 1))}><svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6"/></svg></button>
                </div>
              </nav>
              </>
            ) : <p className="classResultsEmpty">No classes found for the selected filters.</p>}
          </section>
        ) : (
        <>
          <div className={`sidebarList dashboardDataPanel coursesDataPanel ${coursesSidebarCollapsed ? 'coursesDataPanelCollapsed' : ''}`} style={coursesSidebarCollapsed ? { maxWidth: '54px', minWidth: '54px' } : { maxWidth: '300px', minWidth: '260px' }}>
            {coursesSidebarCollapsed ? (
              <button
                type="button"
                className="coursesSidebarRail"
                aria-expanded="false"
                aria-label="Expand courses list"
                title="Expand courses list"
                onClick={() => setCoursesSidebarCollapsed(false)}
              >
                <span aria-hidden="true">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m9 6 6 6-6 6"/></svg>
                </span>
                <span className="coursesSidebarRailLabel">Courses</span>
                <span className="coursesSidebarRailCount">{visibleClassGroups.length}</span>
              </button>
            ) : (<>
            <div className="dashboardDataPanelHeader coursesPanelHeader">
              <div className="coursesPanelTitleRow">
                <span className="coursesPanelIcon" aria-hidden="true">
                  <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m4 19.5 8-4 8 4"/><path d="M4 4.5v15"/><path d="M20 4.5v15"/><path d="M4 4.5h16v11H4z"/></svg>
                </span>
                <div>
                  <h3>Courses</h3>
                  <p>Choose a course to view its students</p>
                </div>
                <button
                  type="button"
                  className="coursesSidebarToggle"
                  aria-expanded="true"
                  aria-label="Collapse courses list"
                  title="Collapse courses list"
                  onClick={() => setCoursesSidebarCollapsed(true)}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 6-6 6 6 6"/></svg>
                </button>
              </div>
            </div>
            {visibleClassGroups.map((classGroup) => (
              <div
                key={classGroup.id}
                className={`sidebarRow ${selectedClassGroup?.id === classGroup.id ? 'activeRow' : ''}`}
                onClick={() => {
                  setSelectedClassId(classGroup.id)
                  setSelectedSubmissionType('eoi')
                  setSelectedRows([])
                  dispatch(setCurrenEoi())
                  dispatch(setCurrenDeclaration())
                }}
              >
                <div className="qldCourseDetails">
                  <div className="qldCourseDetailRow qldCourseDateRow">
                    <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4"/><path d="M8 2v4"/><path d="M3 10h18"/></svg>
                    <span>{format(new Date(classGroup.scheduledDate || classGroup.scheduledDateKey), 'EEE, dd MMM yyyy')}</span>
                    {(classGroup.rows || []).some((row) => (row.submissionType || 'eoi') === 'eoi') &&
                      (classGroup.rows || []).filter((row) => (row.submissionType || 'eoi') === 'eoi').every((row) => row.completed) && (
                        <span className="courseLodgedStatus">
                          <svg aria-hidden="true" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m5 12 4 4L19 6"/></svg>
                          Lodged
                        </span>
                      )}
                  </div>
                  <div className="qldCourseDetailRow">
                    <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>
                    <span>{(classGroup.trainerName || trainers.find((trainer) => trainer.trainerId === classGroup.trainerId)?.name || 'Unassigned trainer').toLowerCase().replace(/\b\w/g, (letter) => letter.toUpperCase())}</span>
                  </div>
                  <div className="qldCourseDetailRow">
                    <svg aria-hidden="true" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="7" r="3"/><circle cx="5" cy="9" r="2.25"/><circle cx="19" cy="9" r="2.25"/><path d="M7 20v-1a5 5 0 0 1 10 0v1"/><path d="M1.5 19v-.5A3.5 3.5 0 0 1 5 15h1"/><path d="M22.5 19v-.5A3.5 3.5 0 0 0 19 15h-1"/></svg>
                    <span>{classGroup.studentCount || 0} Student{classGroup.studentCount === 1 ? '' : 's'}</span>
                  </div>
                  <div className="qldCourseDetailRow" style={{ textTransform: 'capitalize' }}>
                    <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="14" rx="2"/><path d="M8 22h8M12 18v4"/></svg>
                    <span>{classGroup.delivery || 'Not specified'}</span>
                  </div>
                </div>
              </div>
            ))}
            <button className="textButton" onClick={loadMoreStudents}>Load More...</button>
            </>)}
          </div>
          <div className="sidebarList dashboardDataPanel studentPipelinePanel" style={{ flex: 1, maxWidth: 'none', minWidth: '620px' }}>
            <div className="dashboardDataPanelHeader" style={{ padding: '14px 16px', borderBottom: '1px solid #ececec', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '16px' }}>
              <div>
                <h3 style={{ margin: 0, fontSize: '19px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span aria-hidden="true" style={{ display: 'inline-flex', color: '#ca8a04' }}>
                    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="7" r="3"/><circle cx="5" cy="9" r="2.25"/><circle cx="19" cy="9" r="2.25"/><path d="M7 20v-1a5 5 0 0 1 10 0v1"/><path d="M1.5 19v-.5A3.5 3.5 0 0 1 5 15h1"/><path d="M22.5 19v-.5A3.5 3.5 0 0 0 19 15h-1"/></svg>
                  </span>
                  Student Pipeline
                </h3>
                {loadingCourseData && focusedPipeline && <p role="status">Loading this class's student records...</p>}
                {pipelineLoadError && focusedPipeline && <p role="alert">{pipelineLoadError} <button onClick={() => performFetch(false)}>Retry</button></p>}
                <p style={{ margin: '6px 0 0', color: '#64707d', fontSize: '13px', lineHeight: '1.4' }}>
                  Track progress, reopen completed submissions, and generate PDFs once every stage is complete.
                </p>
                <label className="studentPipelineSearch">
                  <svg aria-hidden="true" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
                  <input
                    type="search"
                    value={search}
                    placeholder="Search this class by name, email or DOB"
                    aria-label="Search students in this class"
                    onChange={(event) => setSearch(event.target.value)}
                  />
                  {search && <button type="button" aria-label="Clear student search" onClick={() => setSearch('')}>&times;</button>}
                </label>
              </div>
              {selectedClassGroup && (
                <div style={{ marginLeft: 'auto', textAlign: 'right', flexShrink: 0 }}>
                  <button type="button" className="classResultsBackButton" onClick={() => { setSelectedClassId(''); setSelectedRows([]); setShowClassResults(true) }}>Back to classes</button>
                  <div className="studentPipelineMeta" aria-label="Course date" title="Course date" style={{ color: '#1f2937', marginBottom: '5px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '6px', fontSize: '14px', fontWeight: 600 }}>
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <rect x="3" y="5" width="18" height="16" rx="2" />
                      <path d="M16 3v4M8 3v4M3 11h18" />
                    </svg>
                    <span>{format(new Date(selectedClassGroup.scheduledDate || selectedClassGroup.scheduledDateKey), 'EEE, dd MMM yyyy')}</span>
                  </div>
                  <div className="studentPipelineMeta" aria-label="Trainer" title="Trainer" style={{ color: '#1f2937', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '6px', fontSize: '14px', fontWeight: 600 }}>
                    <svg aria-hidden="true" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="8" r="4" />
                      <path d="M4 21a8 8 0 0 1 16 0" />
                    </svg>
                    <span>{(selectedClassGroup.trainerName || trainers.find((trainer) => trainer.trainerId === selectedClassGroup.trainerId)?.name || 'Unassigned trainer').toLowerCase().replace(/\b\w/g, (letter) => letter.toUpperCase())}</span>
                  </div>
                </div>
              )}
            </div>
            <div className="studentPipelineTableWrap">
              <table style={{ width: '100%', minWidth: isTrafficCourse ? `${Math.max(980, 320 + (trafficControllerPipelineTasks.length + 3) * 150)}px` : '720px', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                {!isTrafficCourse && (
                  <colgroup>
                    <col style={{ width: '28%' }} />
                    <col style={{ width: '24%' }} />
                    <col style={{ width: '24%' }} />
                    <col style={{ width: '24%' }} />
                  </colgroup>
                )}
                <thead style={{ backgroundColor: '#fffbea' }}>
                  <tr>
                    <th style={{ textAlign: 'left', fontSize: '14px', padding: '7px 8px', borderRadius: '8px 0 0 8px' }}>Student Name</th>
                    <th style={{ textAlign: 'center', fontSize: '14px', padding: '7px 8px' }}>LLND + EOI</th>
                    {isTrafficCourse
                      ? trafficControllerPipelineTasks.map((task, index) => (
                        <th
                          key={task.id}
                          style={{
                            textAlign: 'center',
                            fontSize: '13px',
                            padding: '7px 8px',
                            lineHeight: 1.3,
                            minWidth: '150px',
                          }}
                        >
                          {task.name || task.type || `Stage ${index + 1}`}
                        </th>
                      ))
                      : <th style={{ textAlign: 'center', fontSize: '14px', padding: '7px 8px' }}>Declaration</th>}
                    {isTrafficCourse && (
                      <th style={{ textAlign: 'center', fontSize: '14px', padding: '7px 8px' }}>Declaration</th>
                    )}
                    <th style={{ textAlign: 'center', fontSize: '14px', padding: '7px 8px', borderRadius: '0 8px 8px 0' }}>
                      <div>Lodgement</div>
                      <button
                        type="button"
                        onClick={() => {
                          if (enableMultiSelect) {
                            setEnableMultiSelect(false)
                            setSelectedRows([])
                          } else {
                            setSelectedSubmissionType('eoi')
                            setEnableMultiSelect(true)
                            setSelectedRows(studentRosterRows.map((row) => row.eoi).filter(Boolean))
                          }
                        }}
                        style={{
                          margin: '6px 0 0',
                          padding: '6px 9px',
                          minHeight: '28px',
                          border: `1px solid ${enableMultiSelect ? '#d6bd19' : '#d7dce2'}`,
                          borderRadius: '8px',
                          background: enableMultiSelect ? '#fff8cc' : '#ffffff',
                          color: '#374151',
                          fontFamily: "'Rubik', sans-serif",
                          fontSize: '12px',
                          fontWeight: '600',
                          lineHeight: 1,
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '6px',
                          boxShadow: '0 1px 2px rgba(15, 23, 42, 0.06)',
                        }}
                      >
                        <svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="4" y="4" width="16" height="16" rx="3" />
                          {enableMultiSelect && <path d="m8 12 2.5 2.5L16 9" />}
                        </svg>
                        {enableMultiSelect ? 'Clear All' : 'Select All'}
                      </button>
                    </th>
                  </tr>
                  {isTrafficCourse && (
                    <tr className="trafficGroupReleaseRow">
                      <th aria-label="Group Release" style={{ padding: '7px 8px', background: '#ffffff', borderTop: '1px solid #edf1f4' }} />
                      <th style={{ padding: '7px 8px', background: '#ffffff', borderTop: '1px solid #edf1f4' }} />
                      {trafficControllerPipelineTasks.map((task) => {
                        const eligibleCount = getTrafficBulkReleaseEligibleFlows(task).length
                        const isTrainerOnly = task.type === TRAINER_DECLARATION_TYPE
                        const isReleasing = bulkReleasingTrafficTaskId === task.id
                        const markableCount = getTrafficMarkRows(task).filter((markRow) => markRow.eligible).length
                        return (
                          <th key={`${task.id}-release`} style={{ padding: '7px 8px', textAlign: 'center', background: '#ffffff', borderTop: '1px solid #edf1f4' }}>
                            <div className="trafficBulkActionStack">
                            {!isTrainerOnly && (
                              <button
                                type="button"
                                className="trafficReleaseAllButton"
                                onClick={() => handleTrafficBulkRelease(task)}
                                disabled={eligibleCount === 0 || isReleasing}
                                title={eligibleCount === 0 ? 'No locked assessments to release.' : `Release for ${eligibleCount} student${eligibleCount === 1 ? '' : 's'}.`}
                              >
                                {isReleasing ? 'Releasing...' : `Release All${eligibleCount > 0 ? ` (${eligibleCount})` : ''}`}
                              </button>
                            )}
                            {isMarkableTrafficTask(task) && (
                              <button
                                type="button"
                                className="trafficMarkAllButton"
                                onClick={() => openTrafficMarkPopup(task)}
                                disabled={markableCount === 0}
                                title={markableCount === 0 ? 'No submitted work to mark.' : `Mark ${markableCount} submitted student${markableCount === 1 ? '' : 's'}.`}
                              >
                                {`Mark${markableCount > 0 ? ` (${markableCount})` : ''}`}
                              </button>
                            )}
                            </div>
                          </th>
                        )
                      })}
                      <th style={{ padding: '7px 8px', background: '#ffffff', borderTop: '1px solid #edf1f4' }} />
                      <th style={{ padding: '7px 8px', background: '#ffffff', borderTop: '1px solid #edf1f4' }} />
                    </tr>
                  )}
                </thead>
                <tbody>
                  {studentRosterRows.map((row) => {
                    const eoiActive = row.eoi && currentEoi?.id === row.eoi.id
                    const declarationActive = row.declaration && currentDeclaration?.id === row.declaration.id

                    const renderStageCell = (record, type) => {
                      if (!record) {
                        return <span style={{ color: '#9ca3af' }}>-</span>
                      }

                      const isActive = type === 'eoi' ? eoiActive : declarationActive
                      const isMultiSelected = enableMultiSelect && selectedRows.some((selectedRow) => selectedRow.id === record.id)
                      const statusLabel = type === 'eoi'
                        ? (record.verified ? 'Satisfactory' : 'Cannot proceed')
                        : (record.completed ? 'Complete' : 'Submitted')
                      const stageComplete = type === 'declaration' ? Boolean(record.completed) : Boolean(record.verified)

                      return (
                        <div style={{ display: 'grid', gridTemplateColumns: '34px 34px', gridTemplateRows: 'auto', justifyContent: 'center', alignItems: 'center', columnGap: '8px', width: '100%' }}>
                          <button
                            type='button'
                            aria-disabled='true'
                            aria-label={statusLabel}
                            title={statusLabel}
                            style={{
                              width: '34px',
                              alignSelf: 'center',
                              gridColumn: '2',
                              gridRow: '1',
                              minHeight: '28px',
                              maxWidth: '100%',
                              boxSizing: 'border-box',
                              border: type === 'declaration'
                                ? `1px solid ${stageComplete ? '#a7d8b6' : '#f3b35b'}`
                                : (isActive || isMultiSelected) ? '2px solid #111827' : `1px solid ${stageComplete ? '#a7d8b6' : '#e7bcbc'}`,
                              background: stageComplete ? '#edf8f0' : type === 'declaration' ? '#fff1dc' : '#fdecec',
                              color: stageComplete ? '#287a45' : type === 'declaration' ? '#c45f00' : '#8a3030',
                              borderRadius: '10px',
                              padding: 0,
                              fontSize: '12px',
                              fontFamily: "'Rubik', sans-serif",
                              fontWeight: '600',
                              lineHeight: 1.2,
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px',
                              cursor: 'default',
                            }}
                          >
                            <svg aria-hidden='true' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.25' strokeLinecap='round' strokeLinejoin='round'>
                              <circle cx='12' cy='12' r='9' />
                              {stageComplete
                                ? <path d='m8 12 2.7 2.7L16.5 9' />
                                : type === 'declaration'
                                  ? <><path d='M9.6 9a2.7 2.7 0 1 1 4.3 2.2c-1.2.8-1.9 1.3-1.9 2.8' /><path d='M12 17h.01' /></>
                                  : <><path d='m9 9 6 6' /><path d='m15 9-6 6' /></>}
                            </svg>
                          </button>
                          {!enableMultiSelect && (
                            <button
                              type='button'
                              onClick={() => handleStageCellClick(record)}
                              aria-label={`View student ${type === 'eoi' ? 'EOI' : 'declaration'}`}
                              title={`View student ${type === 'eoi' ? 'EOI' : 'declaration'}`}
                              style={{
                                width: '34px',
                                alignSelf: 'center',
                                gridColumn: '1',
                                gridRow: '1',
                                minHeight: '34px',
                                maxWidth: '100%',
                                boxSizing: 'border-box',
                                border: '1px solid #d7dce2',
                                borderRadius: '10px',
                                background: '#ffffff',
                                color: '#475569',
                                padding: 0,
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 1px 2px rgba(15, 23, 42, 0.06)',
                                cursor: 'pointer',
                              }}
                            >
                              <svg aria-hidden='true' width='17' height='17' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                                <path d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z' />
                                <path d='M14 2v6h6' />
                                <path d='M8 13h8' />
                                <path d='M8 17h6' />
                              </svg>
                            </button>
                          )}
                        </div>
                      )
                    }

                    const renderTrafficTaskCell = (flowDoc, task) => {
                      if (!flowDoc || !task) {
                        return <span style={{ color: '#9ca3af' }}>-</span>
                      }

                      const taskState = getTaskState(flowDoc, task.id)
                      const statusLabel = getTrafficStageStatusLabel(taskState)
                      const isActive = selectedSubmissionType === 'builderStage'
                        && selectedTrafficFlowStage?.flowDoc?.id === flowDoc.id
                        && selectedTrafficFlowStage?.taskId === task.id
                      const isComplete = taskState?.status === 'completed'
                      const isSubmitted = taskState?.status === 'submitted'
                      const isAvailable = taskState?.status === 'available'
                      const isTrainerOnly = taskState?.status === 'trainer_only'
                      const background = isComplete
                        ? '#edf8f0'
                        : isSubmitted
                          ? '#fff1dc'
                        : isAvailable
                          ? '#fff7db'
                          : isTrainerOnly
                            ? '#eef2ff'
                            : '#f8fafc'
                      const borderColor = isActive
                        ? '#111827'
                        : isComplete
                          ? '#a7d8b6'
                          : isSubmitted
                            ? '#f3b35b'
                          : isAvailable
                            ? '#f3b35b'
                            : isTrainerOnly
                              ? '#c7d2fe'
                              : '#d7dce2'
                      const textColor = isComplete
                        ? '#287a45'
                        : isSubmitted
                          ? '#c45f00'
                        : isAvailable
                          ? '#b45309'
                          : isTrainerOnly
                            ? '#4338ca'
                            : '#64748b'

                      return (
                        <button
                          type="button"
                          onClick={() => handleTrafficFlowStageClick(flowDoc, task.id)}
                          style={{
                            minWidth: '116px',
                            minHeight: '34px',
                            border: `${isActive ? 2 : 1}px solid ${borderColor}`,
                            borderRadius: '999px',
                            background,
                            color: textColor,
                            padding: '6px 12px',
                            fontSize: '12px',
                            fontFamily: "'Rubik', sans-serif",
                            fontWeight: '600',
                            lineHeight: 1.2,
                            boxShadow: '0 1px 2px rgba(15, 23, 42, 0.06)',
                            cursor: 'pointer',
                          }}
                          title={`${task.name || task.type}: ${statusLabel}`}
                          aria-label={`View ${task.name || task.type} for ${flowDoc.firstName || 'student'} ${flowDoc.lastName || ''}`}
                        >
                          {isComplete && <span aria-hidden="true">&#10003; </span>}{statusLabel}
                        </button>
                      )
                    }

                    const renderLodgementCell = (record) => {
                      if (!record) {
                        return <span style={{ color: '#9ca3af' }}>-</span>
                      }

                      return (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '9px' }}>
                          {enableMultiSelect && (
                            <input
                              type="checkbox"
                              checked={selectedRows.some((selectedRow) => selectedRow.id === record.id)}
                              onChange={() => toggleRow(record)}
                              aria-label={`Select ${record.firstName || record.data?.firstName || 'student'} for lodgement`}
                              style={{ width: '17px', height: '17px', margin: 0, accentColor: '#d6bd19', cursor: 'pointer' }}
                            />
                          )}
                          {record.verified ? <span
                          aria-label={record.completed ? 'Lodged' : 'Not lodged'}
                          title={record.completed ? 'Lodged' : 'Not lodged'}
                          style={{
                            width: record.completed ? '108px' : '34px',
                            minHeight: '30px',
                            maxWidth: '100%',
                            boxSizing: 'border-box',
                            border: `1px solid ${record.completed ? '#a7d8b6' : '#e7bcbc'}`,
                            borderRadius: record.completed ? '9px' : '10px',
                            background: record.completed ? '#edf8f0' : '#fdecec',
                            color: record.completed ? '#287a45' : '#8a3030',
                            padding: record.completed ? '4px 7px' : 0,
                            fontSize: '12px',
                            fontFamily: "'Rubik', sans-serif",
                            fontWeight: '600',
                            lineHeight: 1.2,
                            whiteSpace: 'nowrap',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '6px',
                            boxShadow: '0 1px 2px rgba(15, 23, 42, 0.06)',
                            cursor: 'default',
                          }}
                        >
                          {record.completed ? (
                            <><svg aria-hidden='true' width='17' height='17' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.25' strokeLinecap='round' strokeLinejoin='round'><circle cx='12' cy='12' r='9' /><path d='m8 12 2.7 2.7L16.5 9' /></svg>Lodged</>
                          ) : (
                            <svg aria-hidden='true' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.25' strokeLinecap='round' strokeLinejoin='round'>
                              <circle cx='12' cy='12' r='9' />
                              <path d='m9 9 6 6' />
                              <path d='m15 9-6 6' />
                            </svg>
                          )}
                          </span> : <span style={{ color: '#9ca3af' }}>-</span>}
                        </div>
                      )
                    }

                    return (
                      <tr key={row.id} style={{ borderTop: '1px solid #ececec' }}>
                        <td style={{ padding: '6px 8px', textAlign: 'left', verticalAlign: 'middle' }}>
                          <div style={{ fontSize: '13px' }}>{row.fullName}</div>
                        </td>
                        <td style={{ padding: '6px 8px', textAlign: 'center', verticalAlign: 'middle' }}>{renderStageCell(row.eoi, 'eoi')}</td>
                        {isTrafficCourse
                          ? trafficControllerPipelineTasks.map((task) => (
                            <td key={task.id} style={{ padding: '6px 8px', textAlign: 'center', verticalAlign: 'middle' }}>
                              {renderTrafficTaskCell(row.trafficCourseFlow, task)}
                            </td>
                          ))
                          : <td style={{ padding: '6px 8px', textAlign: 'center', verticalAlign: 'middle' }}>{renderStageCell(row.declaration, 'declaration')}</td>}
                        {isTrafficCourse && (
                          <td style={{ padding: '6px 8px', textAlign: 'center', verticalAlign: 'middle' }}>
                            {renderStageCell(row.declaration, 'declaration')}
                          </td>
                        )}
                        <td style={{ padding: '6px 8px', textAlign: 'center', verticalAlign: 'middle' }}>{renderLodgementCell(row.eoi)}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
            <div className="studentPipelineFooter">
              <span className="qldDashboardStudentCount">
                <svg aria-hidden="true" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="7" r="3"/><circle cx="5" cy="9" r="2.25"/><circle cx="19" cy="9" r="2.25"/><path d="M7 20v-1a5 5 0 0 1 10 0v1"/><path d="M1.5 19v-.5A3.5 3.5 0 0 1 5 15h1"/><path d="M22.5 19v-.5A3.5 3.5 0 0 0 19 15h-1"/></svg>
                <strong>{studentRosterRows.length}</strong>
                <span>students</span>
              </span>
              {enableMultiSelect && selectedRows.length > 0 && (
                <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '8px' }}>
                  {selectedRows[0]?.submissionType === 'eoi' && currentTab === 'White Card' && (
                    <button className="dashboardActionPill" type="button" onClick={() => setShowLodgePopup(true)} style={{ margin: 0 }}>Lodge</button>
                  )}
                  {selectedRows[0]?.submissionType === 'eoi' && isTrafficCourse && (
                    <button className="dashboardActionPill" type="button" onClick={() => setShowLodgeTrafficPopup(true)} style={{ margin: 0 }}>Lodge Traffic(s)</button>
                  )}
                  <button className="dashboardActionPill" type="button" onClick={openDownloadEoiPopup} style={{ margin: 0 }}>Download EOI</button>
                </div>
              )}
              {!enableMultiSelect && (
                <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <button className="dashboardActionPill" type="button" onClick={openDownloadEoiPopup} style={{ margin: 0 }}>Download EOI</button>
                </div>
              )}
            </div>
          </div>


          <ModalComponent
            showModal={showStudentDetailsPopup}
            setShowModal={(value) => {
              setShowStudentDetailsPopup(value)
              if (!value) {
                setSelectedTrafficFlowStage(null)
              }
            }}
            contentStyle={{
              width: '90%',
              maxWidth: selectedSubmissionType === 'builderStage' ? '1100px' : selectedSubmissionType === 'declaration' ? '760px' : '1000px',
              height: selectedSubmissionType === 'eoi' ? '96vh' : 'auto',
              maxHeight: selectedSubmissionType === 'declaration' && currentTab !== 'White Card' ? 'none' : selectedSubmissionType === 'eoi' ? '96vh' : '88vh',
              overflowY: selectedSubmissionType === 'declaration' && currentTab !== 'White Card' ? 'visible' : 'auto',
              boxSizing: 'border-box',
              padding: 0,
              border: 'none',
              borderRadius: '14px',
              background: '#f8fafc',
              boxShadow: '0 24px 60px rgba(15, 23, 42, 0.2)',
            }}
          >
            {verificationStatusMessage && (
              <div
                className={`verificationCenterMessage ${verificationStatusMessage.verified ? 'verified' : 'notVerified'}`}
                role="status"
                aria-live="polite"
              >
                <span aria-hidden="true">{verificationStatusMessage.verified ? '✓' : '×'}</span>
                {verificationStatusMessage.text}
              </div>
            )}
            <div style={{ position: 'sticky', top: 0, zIndex: 20, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px', background: '#fffbea', borderBottom: '1px solid #f1e7a1' }}>
              <div>
                <h2 style={{ margin: 0, fontSize: '19px', color: '#111827' }}>
                  {selectedSubmissionType === 'builderStage'
                    ? (selectedTrafficTask?.name || selectedTrafficTask?.type || 'Traffic Course Section')
                    : selectedSubmissionType === 'declaration'
                      ? 'Declaration'
                      : 'LLND + EOI'}
                </h2>
                <p style={{ margin: '3px 0 0', fontSize: '19px', fontWeight: '400', lineHeight: 1.2, color: '#111827', fontFamily: "'Rubik', sans-serif" }}><strong>Student:</strong> {selectedStudentName}</p>
              </div>
              <div className="qldStageModalHeaderActions">
              {selectedSubmissionType && (
                <div className="studentDetailsModalRecordActions">
                  {selectedSubmissionType !== 'builderStage' && userData && userData.role === 'admin' && userData.hasDeleteAccess && <button className="dashboardActionPill studentDetailsDeletePill" type="button" onClick={() => document.getElementById(selectedSubmissionType === 'declaration' ? 'student-declaration-delete-action' : 'nsw-eoi-delete-action')?.click()}>Delete</button>}
                  {selectedSubmissionType === 'declaration'
                    ? <button className="dashboardActionPill studentDetailsUpdatePill" type="button" onClick={() => {
                      if (isDeclarationEditing) {
                        document.getElementById('student-declaration-update-action')?.click()
                      } else {
                        setIsDeclarationEditing(true)
                      }
                    }}>{isDeclarationEditing ? 'Save' : 'Edit'}</button>
                    : selectedSubmissionType === 'eoi'
                      ? <button className="dashboardActionPill studentDetailsUpdatePill" type="button" onClick={() => document.getElementById('nsw-eoi-update-action')?.click()}>Update</button>
                      : null}
                  <button
                    type="button"
                    className="qldStageModalClose"
                    aria-label="Close student details"
                    onClick={() => {
                      setShowStudentDetailsPopup(false)
                      setSelectedTrafficFlowStage(null)
                    }}
                  >
                    Close
                  </button>
                  {selectedSubmissionType === 'builderStage' && <div id="traffic-stage-header-review-actions" className="trafficStageHeaderReviewActions" />}
                </div>
              )}
              {selectedRecord && (selectedSubmissionType === 'eoi' || selectedSubmissionType === 'declaration') && (
                <div className="qldStageModalDecisionRow">
                  <button
                    className="qldStageDecisionSatisfactory"
                    type="button"
                    aria-label={selectedSubmissionType === 'declaration' ? 'Mark declaration as Satisfactory' : 'Mark ID as Satisfactory'}
                    disabled={selectedRecord.verified || (selectedSubmissionType === 'eoi' && !isTrainerVerificationComplete(selectedRecord.data))}
                    onClick={() => toggleVerified(selectedRecord)}
                    title={selectedSubmissionType === 'eoi' && !isTrainerVerificationComplete(selectedRecord.data) ? 'Complete all trainer detail checks first.' : 'Set as Satisfactory'}
                  >
                    <svg aria-hidden="true" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m5 12 4 4L19 6" /></svg>
                    Satisfactory
                  </button>
                  <button
                    className="qldStageDecisionUnsatisfactory"
                    type="button"
                    aria-label={selectedSubmissionType === 'declaration' ? 'Mark declaration as Cannot proceed' : 'Mark ID as Cannot proceed'}
                    disabled={!selectedRecord.verified}
                    onClick={() => toggleVerified(selectedRecord)}
                    title="Set as Cannot proceed"
                  >
                    <svg aria-hidden="true" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
                    Cannot proceed
                  </button>
                </div>
              )}
              </div>
            </div>
            <div className={`studentDetailsModalBody ${selectedSubmissionType === 'declaration' ? 'declarationDetailsModalBody' : ''}`}>
              <img className="popupPageBrandLogo" src={Logo} alt="Upskill Institute" />
              {selectedSubmissionType === 'builderStage' && selectedTrafficFlowStage
                ? <TrafficCourseStageViewer flowDoc={selectedTrafficFlowStage.flowDoc} taskId={selectedTrafficFlowStage.taskId} userData={userData} onFlowUpdated={handleTrafficFlowUpdated} onClose={() => {
                  setShowStudentDetailsPopup(false)
                  setSelectedTrafficFlowStage(null)
                }} />
                : currentTab === 'White Card'
                ? (
                  selectedSubmissionType === 'declaration'
                    ? <DisplayDeclaration search={search} isAdmin={userData && userData.role === 'admin' && userData.hasDeleteAccess} currentDeclaration={currentDeclaration} fetchDeclaration={() => fetchDeclarations(false, 'declaration')} onActionMessage={(text, verified) => {
                      setVerificationStatusMessage({ text, verified })
                      window.setTimeout(() => setVerificationStatusMessage(null), 2200)
                    }} isEditing={isDeclarationEditing} onEditStart={() => setIsDeclarationEditing(true)} onSaveComplete={() => setIsDeclarationEditing(false)} hideFooterActions />
                    : <DisplayEoi search={search} userData={userData} isAdmin={userData && userData.role === 'admin' && userData.hasDeleteAccess} currentEoi={currentEoi} fetchEoi={() => fetchEoi(false, 'eoi')} onCurrentEoiUpdated={handleCurrentEoiUpdated} onActionMessage={(text, verified) => {
                      setVerificationStatusMessage({ text, verified })
                      window.setTimeout(() => setVerificationStatusMessage(null), 2200)
                    }} hideFooterActions />
                )
                : currentTab === 'Traffic Control'
                  ? (
                    selectedSubmissionType === 'declaration'
                      ? <DisplayTrafficDeclaration search={search} isAdmin={userData && userData.role === 'admin' && userData.hasDeleteAccess} currentDeclaration={currentDeclaration} fetchDeclaration={() => fetchTrafficDeclarations(false, 'dec-trafficControl')} onActionMessage={(text, verified) => {
                        setVerificationStatusMessage({ text, verified })
                        window.setTimeout(() => setVerificationStatusMessage(null), 2200)
                      }} isEditing={isDeclarationEditing} onEditStart={() => setIsDeclarationEditing(true)} onSaveComplete={() => setIsDeclarationEditing(false)} hideFooterActions />
                      : <DisplayTrafficEoi search={search} userData={userData} isAdmin={userData && userData.role === 'admin' && userData.hasDeleteAccess} currentEoi={currentEoi} fetchEoi={() => fetchTrafficEoi(false, 'trafficControl')} onCurrentEoiUpdated={handleCurrentEoiUpdated} onActionMessage={(text, verified) => {
                        setVerificationStatusMessage({ text, verified })
                        window.setTimeout(() => setVerificationStatusMessage(null), 2200)
                      }} hideFooterActions />
                  )
                  : currentTab === 'Traffic Implement'
                    ? (
                      selectedSubmissionType === 'declaration'
                        ? <DisplayTrafficDeclaration search={search} isAdmin={userData && userData.role === 'admin' && userData.hasDeleteAccess} currentDeclaration={currentDeclaration} fetchDeclaration={() => fetchTrafficDeclarations(false, 'dec-trafficImplementation')} onActionMessage={(text, verified) => {
                          setVerificationStatusMessage({ text, verified })
                          window.setTimeout(() => setVerificationStatusMessage(null), 2200)
                        }} isEditing={isDeclarationEditing} onEditStart={() => setIsDeclarationEditing(true)} onSaveComplete={() => setIsDeclarationEditing(false)} hideFooterActions />
                        : <DisplayTrafficEoi search={search} userData={userData} isAdmin={userData && userData.role === 'admin' && userData.hasDeleteAccess} currentEoi={currentEoi} fetchEoi={() => fetchTrafficEoi(false, 'trafficImplementation')} onCurrentEoiUpdated={handleCurrentEoiUpdated} onActionMessage={(text, verified) => {
                          setVerificationStatusMessage({ text, verified })
                          window.setTimeout(() => setVerificationStatusMessage(null), 2200)
                        }} hideFooterActions />
                    )
                    : null}
            </div>
          </ModalComponent>
        </>
        )
      )}
    </div>
      </main>
    </div>

  </div >
}

export default Dashboard
